import ce, { memo as V, useReducer as qe, useCallback as O, useEffect as _, useState as E, useMemo as F, useContext as M, createContext as Ft } from "react";
import { useNavigate as qt, Routes as mt, Route as q } from "react-router-dom";
import { SimpleRedirectBlock as Gt, FormActionsContainer as H, FormElement as I, NAME_COLUMN as be, ActionCell as Ae, ListHeaderSecondary as xe, PageList as fe, ListCell as Ee, SpinnerWidgetContainer as ht, DataSourceLabel as Bt, BaseContentWrapper as Wt, BaseInfoWrapper as Kt, ListHeaderPrimary as Vt, TabsNavigationNew as Ht, BaseEntityContent as Yt, DATE_COLUMN as Jt, AUTHOR_COLUMN as Xt, parseMessageEntity as Zt, SpinnerContainer as Qt } from "@prometheus/features";
import { Grid as p, Input as G, Button as w, Icon as L, Block as J, Select as te, Spinner as X, CheckboxCell as me, Tooltip as Te, IconActionButton as Ge, useNotifications as z, NewTable as le, Box as en, Autocomplete as yt, Typography as he, Alert as tn, Divider as Ne, Checkbox as $e, StatusTag as st, Textarea as nn } from "@prometheus/components";
import { Status as v, AuditLogsAction as sn } from "@prometheus/types";
import { ModalContext as ae, useMetadata as an, useRequest as rn, useDownloadAnalysisTypes as on } from "@prometheus/hooks";
import { api as b, getSortDirection as je, parseFiltersToStringParams as cn, downloadFile as ln, getReducerWithProduce as Be, getUUID as ne, convertOptionsAttributeListToObjectOptionsAttribute as dn, convertObjectOptionsAttributeToOptionsAttributeList as un, isEmpty as gt, uniq as pn, createSortingMethodListConfig as we, createFiltersPanelListConfig as Le, createCrudMethodsListConfig as ve, compact as at, getAccessTypeBadgeColor as mn, getExecutionPolicyBadgeColor as hn, reverse as yn, difference as gn } from "@prometheus/utils";
import { EntityType as We, MetaAttributeTypes as ye, metaAttributesTypes as xt, entityTypes as Tt, EntityTypes as Ke, DataSourceAccessType as ze, DataSourceModelTypes as xn } from "@prometheus/enums";
import { useSelector as Ve, useDispatch as Z } from "react-redux";
import { setBreadcrumbs as Q } from "@prometheus/redux";
import Tn from "@emotion/styled";
import { useTheme as rt } from "@emotion/react";
var Ue = { exports: {} }, ue = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ot;
function jn() {
  if (ot) return ue;
  ot = 1;
  var e = Symbol.for("react.transitional.element"), s = Symbol.for("react.fragment");
  function t(a, r, c) {
    var o = null;
    if (c !== void 0 && (o = "" + c), r.key !== void 0 && (o = "" + r.key), "key" in r) {
      c = {};
      for (var i in r)
        i !== "key" && (c[i] = r[i]);
    } else c = r;
    return r = c.ref, {
      $$typeof: e,
      type: a,
      key: o,
      ref: r !== void 0 ? r : null,
      props: c
    };
  }
  return ue.Fragment = s, ue.jsx = t, ue.jsxs = t, ue;
}
var pe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var it;
function Sn() {
  return it || (it = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h) {
      if (h == null) return null;
      if (typeof h == "function")
        return h.$$typeof === $t ? null : h.displayName || h.name || null;
      if (typeof h == "string") return h;
      switch (h) {
        case T:
          return "Fragment";
        case j:
          return "Profiler";
        case S:
          return "StrictMode";
        case R:
          return "Suspense";
        case W:
          return "SuspenseList";
        case Pt:
          return "Activity";
      }
      if (typeof h == "object")
        switch (typeof h.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), h.$$typeof) {
          case g:
            return "Portal";
          case A:
            return (h.displayName || "Context") + ".Provider";
          case y:
            return (h._context.displayName || "Context") + ".Consumer";
          case N:
            var f = h.render;
            return h = h.displayName, h || (h = f.displayName || f.name || "", h = h !== "" ? "ForwardRef(" + h + ")" : "ForwardRef"), h;
          case re:
            return f = h.displayName || null, f !== null ? f : e(h.type) || "Memo";
          case Je:
            f = h._payload, h = h._init;
            try {
              return e(h(f));
            } catch {
            }
        }
      return null;
    }
    function s(h) {
      return "" + h;
    }
    function t(h) {
      try {
        s(h);
        var f = !1;
      } catch {
        f = !0;
      }
      if (f) {
        f = console;
        var D = f.error, P = typeof Symbol == "function" && Symbol.toStringTag && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return D.call(
          f,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          P
        ), s(h);
      }
    }
    function a(h) {
      if (h === T) return "<>";
      if (typeof h == "object" && h !== null && h.$$typeof === Je)
        return "<...>";
      try {
        var f = e(h);
        return f ? "<" + f + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var h = Ie.A;
      return h === null ? null : h.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function o(h) {
      if (Xe.call(h, "key")) {
        var f = Object.getOwnPropertyDescriptor(h, "key").get;
        if (f && f.isReactWarning) return !1;
      }
      return h.key !== void 0;
    }
    function i(h, f) {
      function D() {
        Ze || (Ze = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          f
        ));
      }
      D.isReactWarning = !0, Object.defineProperty(h, "key", {
        get: D,
        configurable: !0
      });
    }
    function d() {
      var h = e(this.type);
      return Qe[h] || (Qe[h] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), h = this.props.ref, h !== void 0 ? h : null;
    }
    function m(h, f, D, P, ee, K, De, Re) {
      return D = K.ref, h = {
        $$typeof: x,
        type: h,
        key: f,
        props: K,
        _owner: ee
      }, (D !== void 0 ? D : null) !== null ? Object.defineProperty(h, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(h, "ref", { enumerable: !1, value: null }), h._store = {}, Object.defineProperty(h._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(h, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(h, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: De
      }), Object.defineProperty(h, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Re
      }), Object.freeze && (Object.freeze(h.props), Object.freeze(h)), h;
    }
    function u(h, f, D, P, ee, K, De, Re) {
      var $ = f.children;
      if ($ !== void 0)
        if (P)
          if (zt($)) {
            for (P = 0; P < $.length; P++)
              C($[P]);
            Object.freeze && Object.freeze($);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else C($);
      if (Xe.call(f, "key")) {
        $ = e(h);
        var ie = Object.keys(f).filter(function(Ut) {
          return Ut !== "key";
        });
        P = 0 < ie.length ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}", nt[$ + P] || (ie = 0 < ie.length ? "{" + ie.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          P,
          $,
          ie,
          $
        ), nt[$ + P] = !0);
      }
      if ($ = null, D !== void 0 && (t(D), $ = "" + D), o(f) && (t(f.key), $ = "" + f.key), "key" in f) {
        D = {};
        for (var ke in f)
          ke !== "key" && (D[ke] = f[ke]);
      } else D = f;
      return $ && i(
        D,
        typeof h == "function" ? h.displayName || h.name || "Unknown" : h
      ), m(
        h,
        $,
        K,
        ee,
        r(),
        D,
        De,
        Re
      );
    }
    function C(h) {
      typeof h == "object" && h !== null && h.$$typeof === x && h._store && (h._store.validated = 1);
    }
    var l = ce, x = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), j = Symbol.for("react.profiler"), y = Symbol.for("react.consumer"), A = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), W = Symbol.for("react.suspense_list"), re = Symbol.for("react.memo"), Je = Symbol.for("react.lazy"), Pt = Symbol.for("react.activity"), $t = Symbol.for("react.client.reference"), Ie = l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Xe = Object.prototype.hasOwnProperty, zt = Array.isArray, Oe = console.createTask ? console.createTask : function() {
      return null;
    };
    l = {
      react_stack_bottom_frame: function(h) {
        return h();
      }
    };
    var Ze, Qe = {}, et = l.react_stack_bottom_frame.bind(
      l,
      c
    )(), tt = Oe(a(c)), nt = {};
    pe.Fragment = T, pe.jsx = function(h, f, D, P, ee) {
      var K = 1e4 > Ie.recentlyCreatedOwnerStacks++;
      return u(
        h,
        f,
        D,
        !1,
        P,
        ee,
        K ? Error("react-stack-top-frame") : et,
        K ? Oe(a(h)) : tt
      );
    }, pe.jsxs = function(h, f, D, P, ee) {
      var K = 1e4 > Ie.recentlyCreatedOwnerStacks++;
      return u(
        h,
        f,
        D,
        !0,
        P,
        ee,
        K ? Error("react-stack-top-frame") : et,
        K ? Oe(a(h)) : tt
      );
    };
  }()), pe;
}
process.env.NODE_ENV === "production" ? Ue.exports = jn() : Ue.exports = Sn();
var n = Ue.exports;
const Cn = {
  title: "Settings",
  iconName: "admin",
  url: "/admin",
  description: "Application administration, including tenants, roles, data sets, meta data and more.",
  titleButton: "Go to admin panel"
}, bn = V((e) => {
  const { name: s } = e, t = qt(), { title: a, iconName: r, url: c, description: o, titleButton: i } = Cn;
  return /* @__PURE__ */ n.jsx(n.Fragment, { children: s === "home-widget" && /* @__PURE__ */ n.jsx(
    Gt,
    {
      ...e,
      title: a,
      iconName: r,
      onClick: () => t(c),
      description: o,
      buttonName: i
    }
  ) });
}), ge = (e) => String(e).replace(/[_\s-]/g, "").toLowerCase(), se = (e) => {
  if (typeof e == "boolean")
    return e;
  if (Array.isArray(e))
    return e.some((t) => {
      const a = ge(t);
      return a.includes("datasteward") || a.includes("steward") || a.includes("owner");
    });
  if (typeof e == "string") {
    const t = ge(e);
    return t.includes("datasteward") || t.includes("steward") || t.includes("owner");
  }
  const s = e;
  return !!((s == null ? void 0 : s.dataSteward) ?? (s == null ? void 0 : s.steward) ?? (s == null ? void 0 : s.owner));
}, de = (e, s) => Array.isArray(s) && s.some((a) => ge(a) === "admin") ? !0 : typeof e == "boolean" ? e : Array.isArray(e) ? e.some((a) => ge(a).includes("admin")) : typeof e == "string" ? ge(e).includes("admin") : !!(e != null && e.admin), An = (e) => {
  var t;
  const s = se(e.roles);
  return {
    steward: s,
    dataSteward: s,
    owner: !!(((t = e.roles) == null ? void 0 : t.owner) ?? s),
    admin: de(e.roles)
  };
}, Se = (e, s) => async (t, a) => {
  var r;
  try {
    const c = t.added.map((d) => d.object.id), o = t.deleted.map((d) => d.id), i = t.added.reduce(
      (d, m) => (d[m.object.id] = An(m), d),
      {}
    );
    return c.length > 0 && await s.add(c, a, i), o.length > 0 && await s.delete(o), s.update && ((r = t.updated) != null && r.length) && await s.update(t.updated, a), {
      message: `${e} list successfully modified for selected group`
    };
  } catch (c) {
    return {
      message: "Something went wrong",
      error: c
    };
  }
}, fn = (e) => b.get(`/admin/metadata-attribute/${e}/tenant`), En = (e, s) => b.post(`/datasource/${e}/tenant/${s}`), Nn = (e) => b.delete(`/datasource/tenant/${e}`), jt = (e, s) => b.post(`/users/${e}/tenant/${s}`), wn = (e) => b.delete(`/users/tenant/${e}`), St = (e, s, t) => b.put(
  `/users/${e}/tenant/${s}/data-steward`,
  JSON.stringify(t),
  { headers: { "Content-Type": "application/json" } }
), Ct = (e, s, t) => b.put(
  `/users/${e}/tenant/${s}/admin`,
  JSON.stringify(t),
  {
    headers: { "Content-Type": "application/json" }
  }
), bt = (e, s) => b.post(`/admin/metadata-attribute/${e}/tenant/${s}`), Ln = (e) => b.delete(`/admin/metadata-attribute/tenant/${e}`), vn = (e, s) => Promise.all(e.map((t) => En(t, s))), _n = (e) => Promise.all(e.map(Nn)), At = (e, s, t) => Promise.all(
  e.map(async (a) => {
    const r = t == null ? void 0 : t[a];
    se(r) ? await St(a, s, !0) : await jt(a, s), de(r) && await Ct(a, s, !0);
  })
), ft = (e) => Promise.all(e.map(wn)), Et = (e, s) => Promise.all(
  e.flatMap((t) => {
    var r, c, o, i;
    const a = [];
    return ((r = t.roleChanges) != null && r.steward || (c = t.roleChanges) != null && c.dataSteward || (o = t.roleChanges) != null && o.owner) && a.push(
      St(
        t.object.id,
        s,
        se(t.roles)
      )
    ), (i = t.roleChanges) != null && i.admin && a.push(
      Ct(
        t.object.id,
        s,
        de(t.roles)
      )
    ), a;
  })
), In = (e, s) => Promise.all(e.map((t) => bt(t, s))), On = (e) => Promise.all(e.map(Ln)), Dn = (e) => b.post(`/users/tenant/${e}/active`), Rn = () => b.get("/tenant"), kn = (e, s) => b.post(`/tenant${s ? "/" + s : ""}`, e), Mn = (e, s) => b.put(`/tenant/${e}`, s), Pn = (e) => b.delete(`/tenant/${e}`), Nt = (e) => b.get(`/tenant/${e}/analysis-types`), wt = (e, s) => b.put(`/tenant/${e}/analysis-types`, s), $n = (e) => {
  const { pageNumber: s, pageSize: t, sortBy: a, query: r } = e, c = je(a), o = `/admin/metadata-attribute/list?${r || ""}&size=${t || ""}&page=${s || ""}&sort=${c}&filter.metadata.subject=DATA_SOURCE&filter.metadata.subject=COHORT&filter.metadata.subject=CONCEPT_SET`;
  return b.get(o);
}, zn = (e) => b.post(`/${We.ADMIN}/metadata-attribute`, e), Un = (e, s) => b.put(`/${We.ADMIN}/metadata-attribute/${e}`, s), Fn = (e) => b.delete(`/${We.ADMIN}/metadata-attribute/${e}`), qn = (e) => b.get(`/admin/metadata-attribute/tenant/${e}`), Lt = (e) => {
  const { pageNumber: s, pageSize: t, sortBy: a, query: r } = e, c = je(a), o = `/users/admin/list?${r || ""}&size=${t || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, Gn = (e) => {
  const s = `/users/tenant/${e}/candidate`;
  return b.get(s);
}, vt = (e) => b.get(`/users/tenant/${e}`), Bn = (e) => {
  const s = `/users/admin/filter?${e}`;
  return b.get(s);
}, Wn = () => b.get("/users/admin/sorts"), Kn = () => b.get("/study-types"), Vn = (e) => b.post("/study-types", e), Hn = (e) => b.get(`/study-types/${e}`), Yn = (e) => b.get(`/study-types/${e}/consent`), Jn = (e, s) => b.put(`/study-types/${e}`, s), _t = (e, s) => b.post(`/study-types/${e}/consent`, s), Xn = async (e) => {
  try {
    const s = await Vn(e);
    return await _t(s.id, {
      text: e.requireUserConsentMessage,
      required: e.requireUserConsent
    }), {
      ...s,
      requireUserConsent: e.requireUserConsent,
      requireUserConsentMessage: e.requireUserConsentMessage
    };
  } catch (s) {
    return console.error(s), null;
  }
}, Zn = async (e, s) => {
  try {
    const t = await Jn(e, s);
    return await _t(t.id, {
      text: s.requireUserConsentMessage,
      required: s.requireUserConsent
    }), {
      ...t,
      requireUserConsent: s.requireUserConsent,
      requireUserConsentMessage: s.requireUserConsentMessage
    };
  } catch (t) {
    return console.error(t), null;
  }
}, Qn = (e) => b.delete(`/study-types/${e}`), It = () => b.get("/model-type"), es = (e) => b.get(`/model-type/${e}`), ts = (e, s) => b.put(`/model-type/${e}`, s), ns = (e) => b.delete(`/model-type/${e}`), ss = (e, s) => b.put(`/analysis/types/model-types/${e}`, s), as = (e, s) => b.delete(`/analysis/types/${e}/model-types/${s}`), rs = (e) => {
  const { pageNumber: s, pageSize: t, sortBy: a, query: r } = e, c = je(a), o = `/audit/events/list?${r || ""}&size=${t || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, os = (e) => {
  const t = `/audit/events/export/csv?${cn(e) || ""}`;
  b.get(t).then((a) => ln(a, "audit-logs.csv", "text/csv"));
}, is = (e) => b.get(`/audit/events/filter?${e}`), cs = () => b.get("/audit/events/sorts"), ls = () => b.get("/modules"), ds = (e) => b.put("/modules", e);
var Y = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_OPTION = "ADD_OPTION", e.CHANGE_OPTION = "CHANGE_OPTION", e.REMOVE_OPTION = "REMOVE_OPTION", e))(Y || {});
const us = {
  isStartHook: !1,
  isLoading: !1,
  options: {}
}, ps = (e, s) => Be(e, (t) => {
  switch (s.type) {
    case Y.INIT:
      t.options = s.payload;
      break;
    case Y.ADD_OPTION:
      t.options[s.payload.id] = s.payload.value;
      break;
    case Y.CHANGE_OPTION:
      t.options[s.payload.id] = s.payload.value;
      break;
    case Y.REMOVE_OPTION:
      const a = { ...t.options };
      delete a[s.payload], t.options = a;
      break;
  }
}), ms = (e) => {
  const [s, t] = qe(
    ps,
    us
  ), a = O(() => {
    const o = ne();
    t({
      type: Y.ADD_OPTION,
      payload: {
        id: o,
        value: {
          value: ""
        }
      }
    });
  }, []), r = O(
    (o, i, d) => {
      t({
        type: Y.CHANGE_OPTION,
        payload: {
          id: o,
          value: {
            ...s.options[o],
            [i]: d
          }
        }
      });
    },
    [s.options]
  ), c = O((o) => {
    t({
      type: Y.REMOVE_OPTION,
      payload: o
    });
  }, []);
  return _(() => {
    e.length > 0 ? t({
      type: Y.INIT,
      payload: dn(e)
    }) : a();
  }, []), {
    ...s,
    addOption: a,
    changeOption: r,
    removeOption: c
  };
};
var k = /* @__PURE__ */ ((e) => (e.GET_LIST_TENANTS = "GET_LIST_TENANTS", e.GET_LIST_TENANTS_DONE = "GET_LIST_TENANTS_DONE", e.GET_LIST_TENANTS_FAILED = "GET_LIST_TENANTS_FAILED", e.ADD_TO_TENANT = "ADD_TO_TENANT", e.ADD_TO_TENANT_DONE = "ADD_TO_TENANT_DONE", e.ADD_TO_TENANT_FAILED = "ADD_TO_TENANT_FAILED", e.SET_ACTIVE = "SET_ACTIVE", e.SET_ACTIVE_DONE = "SET_ACTIVE_DONE", e.SET_ACTIVE_FAILED = "SET_ACTIVE_FAILED", e.UPDATE_TENANT = "UPDATE_TENANT", e.UPDATE_GROUP = "UPDATE_GROUP", e.DELETE_GROUP = "DELETE_GROUP", e))(k || {}), oe = /* @__PURE__ */ ((e) => (e.INITIAL = "INITIAL", e.LIST_LOADING = "LIST_LOADING", e.LIST_LOADED = "LIST_LOADED", e.ADD_TENANT_LOADING = "ADD_TENANT_LOADING", e.ADD_TENANT_LOADED = "ADD_TENANT_LOADED", e))(oe || {});
const hs = {
  tenants: [],
  groups: [],
  activeTenant: null,
  status: oe.INITIAL,
  error: {}
}, ys = (e, s) => Be(e, (t) => {
  switch (s.type) {
    case k.GET_LIST_TENANTS:
      t.status = oe.LIST_LOADING, t.tenants = [], t.groups = [];
      break;
    case k.GET_LIST_TENANTS_DONE:
      t.tenants = s.payload.tenants, t.groups = s.payload.groups, t.status = oe.LIST_LOADED;
      break;
    case k.UPDATE_GROUP:
      {
        const a = t.groups.findIndex(
          (r) => r.id === s.payload.id
        );
        a !== -1 ? t.groups.splice(a, 1, s.payload) : t.groups.unshift(s.payload);
      }
      break;
    case k.UPDATE_TENANT:
      {
        const a = t.tenants.findIndex(
          (r) => r.id === s.payload.id
        );
        a !== -1 ? t.tenants.splice(a, 1, s.payload) : t.tenants.unshift(s.payload);
      }
      break;
    case k.DELETE_GROUP:
      {
        const a = t.groups.findIndex(
          (r) => r.id === s.payload
        );
        t.groups.splice(a, 1);
      }
      break;
    case k.ADD_TO_TENANT:
      t.status = oe.ADD_TENANT_LOADING;
      break;
    case k.ADD_TO_TENANT_DONE:
      t.status = oe.ADD_TENANT_LOADED;
  }
}), He = (e, s, t = "USERS") => {
  const [a, r] = qe(ys, hs), c = O(async () => {
    r({
      type: k.GET_LIST_TENANTS
    });
    try {
      const l = await Rn();
      r({
        type: k.GET_LIST_TENANTS_DONE,
        payload: {
          tenants: l.filter((x) => !x.parent).map((x) => ({
            ...x,
            active: e.activeTenant === x.id
          })),
          groups: l.filter(
            (x) => x.parent && !x.terminated
          )
        }
      });
    } catch {
      r({
        type: k.GET_LIST_TENANTS_FAILED
      });
    }
  }, []), o = (l) => {
    r({
      type: k.UPDATE_GROUP,
      payload: l
    });
  }, i = (l) => {
    r({
      type: k.DELETE_GROUP,
      payload: l
    });
  }, d = (l) => {
    r({
      type: k.UPDATE_TENANT,
      payload: l
    });
  }, m = O(async (l) => {
    r({
      type: k.ADD_TO_TENANT
    });
    const x = [];
    l.forEach((g) => {
      x.push(
        t === "USERS" ? jt(s.id, g) : bt(s.id, g)
      );
    });
    try {
      await Promise.all(x), r({
        type: k.ADD_TO_TENANT_DONE
      });
    } catch {
    }
  }, []), u = O(() => {
  }, []), C = O(async (l) => {
    r({
      type: k.SET_ACTIVE
    });
    try {
      await Dn(l), r({
        type: k.SET_ACTIVE_DONE
      });
    } catch {
    }
  }, []);
  return _(() => {
    c();
  }, [e.id]), {
    ...a,
    updateGroups: o,
    updateTenant: d,
    deleteGroups: i,
    setActiveTenant: C,
    getTenants: c,
    addEntityToTenant: m,
    removeTenant: u
  };
};
var Ot = /* @__PURE__ */ ((e) => (e.INITIAL = "INITIAL", e.LOADING_LIST = "LOADING_LIST", e.LOADED_LIST = "LOADED_LIST", e.FAILED_LOADED_LIST = "FAILED_LOADED_LIST", e.CREATING_USER = "CREATING_USER", e.CREATED_USER = "CREATED_USER", e))(Ot || {});
Ot.INITIAL;
const gs = (e) => {
  const { initOptions: s, onChange: t } = e, { options: a, addOption: r, removeOption: c, changeOption: o } = ms(s);
  return _(() => {
    t(un(a));
  }, [a]), /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 1, children: [
    Object.keys(a).map((i) => {
      const d = a[i];
      return /* @__PURE__ */ n.jsxs(
        p,
        {
          item: !0,
          xs: 12,
          container: !0,
          spacing: 2,
          alignItems: "center",
          classes: {
            root: "metadata-attribute-option"
          },
          children: [
            /* @__PURE__ */ n.jsx(p, { item: !0, flexGrow: 1, children: /* @__PURE__ */ n.jsx(
              G,
              {
                id: "value",
                name: "value",
                type: "text",
                size: "medium",
                placeholder: "Enter option",
                value: d.value,
                onChange: (m) => o(i, "value", m.target.value),
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ n.jsx(p, { item: !0, children: /* @__PURE__ */ n.jsx(
              w,
              {
                disabled: Object.keys(a).length === 1,
                onClick: () => {
                  c(i);
                },
                size: "small",
                sx: { minWidth: 0 },
                children: /* @__PURE__ */ n.jsx(
                  L,
                  {
                    iconName: "delete",
                    fontSize: "small",
                    color: Object.keys(a).length === 1 ? "disabled" : "error"
                  }
                )
              }
            ) })
          ]
        },
        i
      );
    }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(H, { children: /* @__PURE__ */ n.jsx(
      w,
      {
        onClick: r,
        variant: "text",
        startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "add" }),
        sx: { textDecoration: "underline" },
        className: "add-option",
        children: "Add new option"
      }
    ) }) })
  ] });
}, ct = V((e) => {
  const { onClose: s, onAdd: t, values: a, isUpdate: r, onUpdate: c } = e, [o, i] = E(!1), [d, m] = E({
    title: (a == null ? void 0 : a.name) || "",
    type: (a == null ? void 0 : a.type) || ye.STRING,
    options: (a == null ? void 0 : a.options) || [],
    metadataSubjects: (a == null ? void 0 : a.metadataSubjects) || []
  }), u = O(async () => {
    i(!0), r ? c(d, a) : t({
      id: ne(),
      ...d
    }), s();
  }, [d]), C = F(() => {
    const l = d.options.find(
      (x) => gt(x.value)
    );
    return !!(!d.title || !d.type || l || d.metadataSubjects.length == 0);
  }, [d]);
  return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ n.jsx(
      G,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        placeholder: "Enter title",
        value: d.title,
        onChange: (l) => {
          m((x) => ({ ...x, title: l.target.value }));
        },
        fullWidth: !0,
        required: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 6, children: /* @__PURE__ */ n.jsx(I, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ n.jsx(
      te,
      {
        className: "",
        name: "type",
        disablePortal: !0,
        id: "type",
        options: xt,
        value: d.type,
        placeholder: "Select type",
        onChange: (l) => {
          m({ ...d, type: l });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 6, children: /* @__PURE__ */ n.jsx(I, { name: "subject", textLabel: "Subject", required: !0, children: /* @__PURE__ */ n.jsx(
      te,
      {
        className: "",
        name: "subject",
        disablePortal: !0,
        id: "subject",
        multiple: !0,
        options: Tt,
        value: d.metadataSubjects,
        placeholder: "Select subject",
        onChange: (l) => {
          m({ ...d, metadataSubjects: l });
        },
        fullWidth: !0
      }
    ) }) }),
    (ye.ENUM == d.type || ye.ENUM_MULTI == d.type) && /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "options", textLabel: "Options", required: !0, children: /* @__PURE__ */ n.jsx(
      gs,
      {
        initOptions: d.options,
        onChange: (l) => {
          m({
            ...d,
            options: l
          });
        }
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
      /* @__PURE__ */ n.jsx(
        w,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        w,
        {
          disabled: o || C,
          onClick: u,
          variant: "contained",
          color: "success",
          startIcon: o ? /* @__PURE__ */ n.jsx(X, { size: 16 }) : /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), Me = {
  entityBreadcrumb: (e) => [
    {
      name: "Settings",
      path: `${e}`
    },
    {
      name: "Metadata",
      path: `${e}/metadata`
    }
  ],
  filterMetadata: "&filter.metadata.subject=DATA_SOURCE&filter.metadata.subject=CONCEPT_SET&filter.metadata.subject=COHORT",
  createCols: (e, s) => [
    // Plain (non-bold) name to match the other Settings tabs — PRO-3961 #10.
    be({
      minSize: 200,
      cell: ({ getValue: t }) => t() ?? "-"
    }),
    {
      header: "Type of value",
      accessorKey: "type",
      cell: (t) => xt.find(
        (a) => a.value == t.getValue()
      ).name
    },
    {
      header: "Subjects",
      accessorKey: "metadataSubjects",
      isCropped: !0,
      enableSorting: !1,
      maxWidth: 200,
      cell: (t) => pn(t.getValue()).map((a) => {
        var r;
        return (r = Tt.find((c) => c.value === a)) == null ? void 0 : r.name;
      }).join(", ")
    },
    {
      header: "Values",
      accessorKey: "options",
      size: 100,
      maxSize: 100,
      cell: (t) => {
        var r;
        const a = t.row.original.type;
        return a === ye.ENUM || a === ye.ENUM_MULTI ? /* @__PURE__ */ n.jsx(n.Fragment, { children: (r = t.row.original.options) == null ? void 0 : r.length }) : /* @__PURE__ */ n.jsx(n.Fragment, { children: "-" });
      }
    },
    {
      header: "Required",
      accessorKey: "required",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "Searchable",
      accessorKey: "searchable",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "Filter display",
      accessorKey: "filterable",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "Table display",
      accessorKey: "visible",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "",
      accessorKey: "id",
      enableSorting: !1,
      size: 90,
      maxSize: 90,
      meta: { columnType: "action" },
      cell: (t) => /* @__PURE__ */ n.jsx(
        Ae,
        {
          entityType: t.row.original.name,
          withConfirmation: !0,
          onRemove: () => e(t.row.original.id),
          children: /* @__PURE__ */ n.jsx(Te, { text: "Add to tenant", color: "primary", width: "auto", children: /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(
            Ge,
            {
              iconName: "add",
              color: "default",
              size: "small",
              noExpand: !0,
              onClick: (a) => {
                a.stopPropagation(), s(t.row.original);
              }
            }
          ) }) })
        }
      )
    }
  ]
}, Ye = V((e) => {
  var g;
  const { onClose: s, user: t, typeEntity: a } = e, { enqueueSnackbar: r } = z(), [c, o] = E(!1), [i, d] = E({
    tenants: []
  }), m = Ve(
    (T) => T.user
  ), { tenants: u, status: C, addEntityToTenant: l } = He(
    m.data,
    t,
    a
  );
  _(() => {
    C === oe.ADD_TENANT_LOADED && (o(!1), r({
      message: "User added to tenant",
      variant: "success"
    }));
  }, [C]);
  const x = O(async () => {
    o(!0);
    try {
      await l(i.tenants);
    } catch {
      o(!1);
    }
    s();
  }, [i]);
  return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "tenants", textLabel: "Your tenants", children: ((g = t.tenants) == null ? void 0 : g.length) > 0 ? t.tenants.map((T) => /* @__PURE__ */ n.jsx("p", { children: T.object.title })) : /* @__PURE__ */ n.jsx("p", { children: "-" }) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "tenants", textLabel: "Tenants", required: !0, children: /* @__PURE__ */ n.jsx(
      te,
      {
        className: "",
        name: "tenants",
        disablePortal: !0,
        id: "proType",
        options: u.filter((T) => {
          var S;
          return !((S = t == null ? void 0 : t.tenants) != null && S.includes(T.id));
        }).map((T) => ({
          value: T.id,
          name: T.title
        })),
        value: i.tenants,
        placeholder: "Select tenants",
        multiple: !0,
        onChange: (T) => {
          d({
            ...i,
            tenants: T
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
      /* @__PURE__ */ n.jsx(
        w,
        {
          variant: "outlined",
          disabled: c,
          onClick: s,
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        w,
        {
          onClick: x,
          disabled: c || i.tenants.length === 0,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), xs = () => {
  const e = Z(), { openModal: s, closeModal: t } = M(ae), { path: a } = M(
    B
  ), [r, c] = E(), { enqueueSnackbar: o } = z();
  _(() => {
    e(Q(Me.entityBreadcrumb(a)));
  }, [a]);
  const {
    data: i,
    addAttribute: d,
    updateAttribute: m,
    editAttribute: u,
    removeAttribute: C,
    isLoading: l,
    changeMessage: x
  } = an(
    Me.filterMetadata,
    !1,
    !0,
    zn,
    Un,
    Fn
  ), g = async (y) => {
    const A = await fn(y.id);
    s(
      () => /* @__PURE__ */ n.jsx(
        Ye,
        {
          user: {
            ...y,
            tenants: A
          },
          typeEntity: Ke.METADATA,
          onClose: () => {
            c(ne()), t();
          }
        }
      ),
      "Add meta attribute to tenant",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  }, T = () => {
    s(
      () => /* @__PURE__ */ n.jsx(
        ct,
        {
          onAdd: d,
          onClose: t,
          isLoading: l
        }
      ),
      "Add attribute",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  }, S = (y) => {
    s(
      () => /* @__PURE__ */ n.jsx(
        ct,
        {
          values: y,
          isUpdate: !0,
          onUpdate: m,
          onClose: t,
          isLoading: l
        }
      ),
      "Update attribute",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  };
  _(() => {
    x && o({
      message: x,
      variant: "success"
    });
  }, [x]);
  const j = F(() => Me.createCols(C, g), []);
  return ce.useEffect(() => {
    document.title = "Prometheus - Metadata";
  }, []), /* @__PURE__ */ n.jsx(p, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
    /* @__PURE__ */ n.jsx(
      xe,
      {
        title: "Metadata",
        canCreate: !0,
        onCreate: T,
        createButtonName: "Add attribute"
      }
    ),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      le,
      {
        columns: j,
        data: i,
        loadingMessage: "",
        totalElements: i == null ? void 0 : i.length,
        loading: l,
        pinnedColumns: { left: ["name"] },
        hideSettings: !0,
        onRowClick: (y) => {
          S(y.original);
        },
        onEdit: (y) => {
          u(y);
        }
      }
    ) })
  ] }) });
}, Ts = () => ({
  rowId: "id",
  loadingMessage: "Loading users...",
  addButtonTitle: "Add user",
  tableTitle: "Users",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (e, s) => ve(
    e,
    s,
    Lt
  ),
  createFiltersPanel: (e, s) => Le(
    e,
    s,
    Bn
  ),
  createSortingMethod(e) {
    return we(e, { getSorting: Wn });
  },
  cols: [
    {
      header: "First name",
      accessorKey: "firstName",
      id: "firstName"
    },
    {
      header: "Last name",
      accessorKey: "lastName",
      id: "lastName"
    },
    {
      header: "Tenants",
      accessorFn: (e) => {
        var s;
        return ((s = e.tenants) == null ? void 0 : s.map((t) => {
          var a;
          return (a = t == null ? void 0 : t.object) == null ? void 0 : a.title;
        }).join(", ")) || "-";
      },
      id: "tenants"
    },
    {
      header: "Email",
      accessorKey: "email",
      id: "email",
      size: 220
    }
  ]
}), js = () => {
  const e = Z(), { openModal: s, closeModal: t } = M(ae), a = M(
    B
  ), [r, c] = E();
  _(() => {
    e(
      Q([
        {
          name: "Settings",
          path: `${a.path}`
        },
        {
          name: "Users",
          path: `${a.path}/users`
        }
      ])
    );
  }, [a.path]);
  const o = (i) => {
    s(
      () => /* @__PURE__ */ n.jsx(
        Ye,
        {
          user: i,
          typeEntity: Ke.USERS,
          onClose: () => {
            c(ne()), t();
          }
        }
      ),
      "Add user to tenant",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  };
  return /* @__PURE__ */ n.jsx(p, { container: !0, children: /* @__PURE__ */ n.jsx(
    fe,
    {
      moduleConfig: a,
      listConfig: Ts(),
      onRowClick: () => {
      },
      reloadId: r,
      variant: "no-header",
      renderRowActions: (i) => /* @__PURE__ */ n.jsx(Te, { text: "Add to tenant", color: "primary", width: "auto", children: /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(
        Ge,
        {
          iconName: "add",
          color: "default",
          size: "small",
          noExpand: !0,
          onClick: (d) => {
            d.stopPropagation(), o(i);
          }
        }
      ) }) })
    }
  ) });
};
var U = /* @__PURE__ */ ((e) => (e.DATA_SOURCES = "data_sources", e.USERS = "users", e.METADATA = "metadata", e))(U || {});
const Dt = (e) => {
  const { pageNumber: s, pageSize: t, sortBy: a, query: r } = e, c = je(a), o = `/datasource/admin/list?${r || ""}&size=${t || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, Ss = (e) => {
  const s = `/datasource/admin/filter?${e}`;
  return b.get(s);
}, Cs = (e, s) => b.post(`/datanodes/${e}`, s), Rt = (e) => {
  const { pageNumber: s, pageSize: t, sortBy: a, query: r } = e, c = je(a), o = `/datanodes/list?${r || ""}&size=${t || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, bs = (e) => {
  const s = `/datanodes/filter?${e}`;
  return b.get(s);
}, As = () => Promise.resolve(["name", "nodeAddress", "registrarAddress", "description"]), fs = () => b.get("/datasource/admin/sorts"), Es = (e, s) => b.put(`/data-sources/${e}`, s), Ns = (e) => b.post("/data-sources", e), ws = (e) => b.get(`/data-sources/default/${e}`), Ls = (e, s) => b.post(`/data-sources/default/${s}/${e}`), vs = (e) => b.get(`/data-sources/with-record-counts/${e}`), _s = (e) => b.get(`/datasource/tenant/${e}`);
function Is(e) {
  const [s, t] = E(null), [a, r] = E(v.INITIAL), [c, o] = E([]), [i, d] = E(v.INITIAL), m = async () => {
    d(v.IN_PROGRESS);
    try {
      const l = await vs(e);
      o(l), d(v.SUCCESS);
    } catch (l) {
      console.error(l), d(v.ERROR);
    }
  }, u = async () => {
    r(v.IN_PROGRESS);
    try {
      const l = await ws(e);
      t(l), r(v.SUCCESS);
    } catch (l) {
      console.error(l), r(v.ERROR);
    }
  }, C = async (l) => {
    r(v.IN_PROGRESS);
    try {
      if (l) {
        const x = await Ls(e, l);
        t(x);
      } else
        t(null);
      r(v.SUCCESS);
    } catch (x) {
      console.error(x), r(v.ERROR);
    }
  };
  return _(() => {
    u();
  }, [e]), _(() => {
    m();
  }, [e]), { dataSource: s, status: a, dataSources: c, listStatus: i, updateDataSource: C };
}
const Os = (e) => {
  const { status: s, dataSource: t, dataSources: a, listStatus: r, updateDataSource: c } = Is(e.value || e.getValue());
  return /* @__PURE__ */ n.jsx(
    en,
    {
      onClick: (o) => {
        o.stopPropagation();
      },
      width: 220,
      children: /* @__PURE__ */ n.jsx(
        yt,
        {
          value: t,
          fullWidth: !0,
          size: "small",
          onChange: (o, i) => {
            c(i == null ? void 0 : i.id);
          },
          placeholder: "Select default Data Source",
          options: a,
          getOptionLabel: function(o) {
            return o.name || "";
          },
          isOptionEqualToValue: (o, i) => o.id === i.id,
          loading: s === v.IN_PROGRESS || r === v.IN_PROGRESS,
          disableClearable: !0
        }
      )
    }
  );
}, Ds = {
  add: At,
  delete: ft,
  update: Et
}, Rs = {
  add: vn,
  delete: _n
}, ks = {
  add: In,
  delete: On
}, Ms = (e, s, t) => [
  {
    header: "Name",
    accessorKey: "title"
  },
  {
    header: "Active",
    accessorKey: "active",
    size: 40,
    maxSize: 40,
    enableSorting: !1,
    meta: { align: "center", headerAlign: "center" },
    cell: (a) => /* @__PURE__ */ n.jsx(
      Te,
      {
        text: a.value ? "Active" : "Not active",
        color: "primary",
        width: "auto",
        children: /* @__PURE__ */ n.jsx("div", { children: a.value ? /* @__PURE__ */ n.jsx(L, { iconName: "check", className: "icon-analysis" }) : /* @__PURE__ */ n.jsx(n.Fragment, { children: "-" }) })
      }
    )
  },
  {
    header: "Data sources",
    accessorKey: "data-sources",
    meta: { align: "center", headerAlign: "center" },
    enableSorting: !1,
    cell: (a) => /* @__PURE__ */ n.jsx(
      w,
      {
        onClick: (r) => {
          r.stopPropagation(), e(a.row.original.id, !!a.row.original.parent);
        },
        variant: "text",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "data sources"
      }
    )
  },
  {
    header: "Users",
    accessorKey: "participants",
    meta: { align: "center", headerAlign: "center" },
    size: 80,
    maxSize: 80,
    enableSorting: !1,
    cell: (a) => /* @__PURE__ */ n.jsx(
      w,
      {
        onClick: (r) => {
          r.stopPropagation(), s(
            a.row.original.id,
            !!a.row.original.parent
          );
        },
        variant: "text",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "users"
      }
    )
  },
  {
    header: "Metadata",
    accessorKey: "metadata",
    meta: { align: "center", headerAlign: "center" },
    enableSorting: !1,
    cell: (a) => /* @__PURE__ */ n.jsx(
      w,
      {
        onClick: (r) => {
          r.stopPropagation(), t(a.row.original.id, !!a.row.original.parent);
        },
        variant: "text",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "metadata"
      }
    )
  },
  {
    header: "Analysis Types",
    accessorFn: (a) => {
      var r, c;
      return ((c = (r = a.relations) == null ? void 0 : r.analysisTypes) == null ? void 0 : c.length) > 0 ? a.relations.analysisTypes.map((o) => o.name) : ["All analyses"];
    },
    cell: Ee,
    width: "25%",
    isCropped: !0,
    enableSorting: !1
  },
  {
    header: "Default source for counts (RC/DRC PC/DPC)",
    id: "rc-data-source",
    accessorKey: "id",
    enableSorting: !1,
    size: 240,
    minSize: 240,
    meta: { columnType: "action" },
    cell: Os
  }
  // Delete action intentionally hidden: there are no CRUD operations for
  // Tenants in the app (added via config by DevOps) — PRO-3961 #3.
], _e = V(
  (e) => {
    const { study: s, analysisTypes: t, onChange: a, isLogger: r, onChangeLogger: c } = e, [o] = E(s.analysisTypes), [i, d] = E(
      s.analysisTypes
    ), m = (x, g) => x.map((T) => ({ value: T.type, name: T.name })).filter((T) => !(i.includes(T.value) && T.value !== g)).sort(
      (T, S) => T.name.localeCompare(S.name, void 0, {
        sensitivity: "base"
      })
    ), u = () => {
      d([...i, ""]);
    }, C = (x) => {
      const g = [...i];
      g.splice(x, 1), d(g);
    }, l = (x, g) => {
      d((T) => {
        let S = [...T];
        return S.splice(
          x === "up" ? g - 1 : g + 1,
          0,
          S.splice(g, 1)[0]
        ), S;
      });
    };
    return _(() => {
      r ? c({
        updated: at(i),
        deleted: o.filter(
          (x) => !i.includes(x)
        )
      }) : a(at(i));
    }, [i]), /* @__PURE__ */ n.jsxs(p, { container: !0, mt: 1, children: [
      /* @__PURE__ */ n.jsx(p, { container: !0, spacing: 2, children: i.map((x, g) => /* @__PURE__ */ n.jsxs(
        p,
        {
          container: !0,
          item: !0,
          xs: 12,
          alignItems: "center",
          spacing: 1,
          children: [
            /* @__PURE__ */ n.jsx(p, { item: !0, children: /* @__PURE__ */ n.jsxs(he, { variant: "subtitle2", component: "span", children: [
              g + 1,
              "."
            ] }) }),
            /* @__PURE__ */ n.jsxs(p, { item: !0, children: [
              /* @__PURE__ */ n.jsx(
                w,
                {
                  onClick: () => {
                    l("up", g);
                  },
                  variant: "outlined",
                  sx: {
                    minWidth: 30,
                    height: 30,
                    borderColor: "borderColor.main",
                    p: 0,
                    mr: 0.5
                  },
                  disabled: g === 0,
                  children: /* @__PURE__ */ n.jsx(
                    L,
                    {
                      iconName: "chevron",
                      sx: { fontSize: 14, transform: "rotate(180deg)" }
                    }
                  )
                }
              ),
              /* @__PURE__ */ n.jsx(
                w,
                {
                  onClick: () => {
                    l("down", g);
                  },
                  variant: "outlined",
                  sx: {
                    minWidth: 30,
                    height: 30,
                    p: 0,
                    borderColor: "borderColor.main"
                  },
                  disabled: g === (i == null ? void 0 : i.length) - 1,
                  children: /* @__PURE__ */ n.jsx(L, { iconName: "chevron", sx: { fontSize: 14 } })
                }
              )
            ] }),
            /* @__PURE__ */ n.jsx(p, { item: !0, flexGrow: 1, children: /* @__PURE__ */ n.jsx(
              te,
              {
                className: "analysisTypes",
                name: "analysisTypes",
                disablePortal: !0,
                id: "analysisTypes",
                options: m(t, x),
                value: x,
                placeholder: "Select analysis types...",
                onChange: (T) => {
                  const S = [...i];
                  S.splice(g, 1, T), d(S);
                },
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ n.jsx(p, { item: !0, children: /* @__PURE__ */ n.jsx(
              w,
              {
                onClick: () => {
                  C(g);
                },
                sx: { minWidth: 0, height: 30 },
                children: /* @__PURE__ */ n.jsx(
                  L,
                  {
                    iconName: "delete",
                    fontSize: "small",
                    color: "error",
                    sx: { fontSize: 16 }
                  }
                )
              }
            ) })
          ]
        },
        g + "analysis-type"
      )) }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ n.jsx(
        w,
        {
          disabled: t.length === i.length,
          onClick: u,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "add" }),
          name: "add",
          children: "Add Analysis Type"
        }
      ) })
    ] });
  }
), Ps = V((e) => {
  const { onClose: s, values: t, analysisTypes: a, onFinish: r, currentAnalysisTypes: c } = e, [o, i] = E(!1), { enqueueSnackbar: d } = z(), [m, u] = E({
    id: t == null ? void 0 : t.id,
    title: (t == null ? void 0 : t.title) || "",
    analysisTypes: c || []
  }), C = O(async () => {
    i(!0);
    try {
      await wt(t.id, m.analysisTypes), r({
        ...t,
        relations: {
          analysisTypes: a.filter(
            (x) => m.analysisTypes.includes(x.type)
          )
        }
      }), i(!1);
    } catch (x) {
      i(!1), d({
        message: "Something went wrong",
        variant: "error"
      }), console.error(x);
    }
  }, [m]), l = F(() => !m.title, [m]);
  return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ n.jsx(
      G,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        placeholder: "Enter title...",
        disabled: !0,
        value: m.title,
        onChange: (x) => {
          u((g) => ({ ...g, title: x.target.value }));
        },
        fullWidth: !0,
        required: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ n.jsx(tn, { severity: "info", children: "Unless explicitly specified below, all analysis types will be accessible without restrictions." }) }),
    /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
      /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Analysis Types" }),
      /* @__PURE__ */ n.jsx(
        _e,
        {
          study: {
            analysisTypes: m.analysisTypes
          },
          analysisTypes: a,
          onChange: (x) => {
            u((g) => ({
              ...g,
              analysisTypes: x
            }));
          }
        }
      ),
      /* @__PURE__ */ n.jsx(Ne, { sx: { mt: 2 } })
    ] }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
      /* @__PURE__ */ n.jsx(
        w,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        w,
        {
          disabled: o || l,
          onClick: C,
          variant: "contained",
          color: "success",
          startIcon: o ? /* @__PURE__ */ n.jsx(X, { size: 16 }) : /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
          name: "save",
          children: t ? "Change" : "Create"
        }
      )
    ] }) })
  ] }) }) });
}), $s = Tn(p)`
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid
    ${({ theme: e }) => e.palette.borderColor.light};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  svg {
    font-size: 16px;
  }
`, kt = (e) => {
  var a, r, c, o, i, d, m;
  const s = (e == null ? void 0 : e.roles) || ((a = e == null ? void 0 : e.object) == null ? void 0 : a.roles), t = se(
    (e == null ? void 0 : e.dataSteward) ?? (e == null ? void 0 : e.steward) ?? (e == null ? void 0 : e.owner) ?? ((r = e == null ? void 0 : e.object) == null ? void 0 : r.dataSteward) ?? ((c = e == null ? void 0 : e.object) == null ? void 0 : c.steward) ?? ((o = e == null ? void 0 : e.object) == null ? void 0 : o.owner) ?? s
  );
  return {
    steward: t,
    dataSteward: t,
    owner: !!((e == null ? void 0 : e.owner) ?? ((i = e == null ? void 0 : e.object) == null ? void 0 : i.owner) ?? (s == null ? void 0 : s.owner) ?? t),
    admin: de(
      (e == null ? void 0 : e.admin) ?? ((d = e == null ? void 0 : e.object) == null ? void 0 : d.admin) ?? s ?? (e == null ? void 0 : e.actions) ?? ((m = e == null ? void 0 : e.object) == null ? void 0 : m.actions)
    )
  };
}, Fe = (e) => {
  var s;
  return {
    steward: se(e == null ? void 0 : e.roles),
    dataSteward: se(e == null ? void 0 : e.roles),
    owner: !!(((s = e == null ? void 0 : e.roles) == null ? void 0 : s.owner) ?? se(e == null ? void 0 : e.roles)),
    admin: de(e == null ? void 0 : e.roles)
  };
}, zs = (e, s) => Object.values(Mt(e, s)).some(Boolean), Mt = (e, s) => {
  const t = Fe(e), a = Fe(s);
  return {
    steward: t.steward !== a.steward,
    dataSteward: t.dataSteward !== a.dataSteward,
    owner: t.owner !== a.owner,
    admin: t.admin !== a.admin
  };
}, Us = (e, s) => {
  if (!(!e && !s))
    return {
      steward: !!(e != null && e.steward || s != null && s.steward),
      dataSteward: !!(e != null && e.dataSteward || s != null && s.dataSteward),
      owner: !!(e != null && e.owner || s != null && s.owner),
      admin: !!(e != null && e.admin || s != null && s.admin)
    };
}, Fs = (e) => Array.from(
  e.reduce((s, t) => {
    const a = t.object.id, r = s.get(a);
    return r ? (s.set(a, {
      ...r,
      roles: Us(r.roles, t.roles)
    }), s) : (s.set(a, t), s);
  }, /* @__PURE__ */ new Map()).values()
), qs = (e, s) => (e.object.title || "").localeCompare(
  s.object.title || "",
  void 0,
  { sensitivity: "base" }
) || e.object.id.localeCompare(s.object.id), Pe = (e) => [...e].sort(qs), Gs = (e) => ({
  id: "",
  object: {
    id: e.id,
    title: e.firstName ? `${e.firstName} ${e.lastName}` : e.name,
    moduleIds: e.moduleIds
  },
  roles: kt(e)
}), Bs = {
  list: [],
  original: [],
  initialTenantList: [],
  selectedTenantList: [],
  status: v.INITIAL,
  error: null
}, Ws = (e, s) => Be(e, (t) => {
  switch (s.type) {
    case "GET_LIST":
      t.status = v.IN_PROGRESS;
      break;
    case "GET_LIST_SUCCESS":
      t.original = s.payload.original, t.list = s.payload.list, t.initialTenantList = s.payload.tenantList, t.selectedTenantList = s.payload.tenantList, t.status = v.SUCCESS;
      break;
    case "CHANGE_SELECTED_LIST":
      t.selectedTenantList = s.payload;
      break;
    case "GET_LIST_FAILED":
      t.status = v.ERROR, t.error = s.payload;
  }
}), Ks = (e, s, t, a) => {
  const [r, c] = qe(
    Ws,
    Bs
  ), o = async () => {
    c({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const u = s ? await t(e) : await t({
        pageSize: 1e4
      }), C = await a(e), l = Fs(
        C.map((g) => ({
          ...g,
          roles: kt(g)
        }))
      ), x = u.content || u;
      c({
        type: "GET_LIST_SUCCESS",
        payload: {
          original: x,
          list: Pe(
            x.map((g) => l.find((S) => S.object.id === g.id) || Gs(g))
          ),
          tenantList: Pe(l)
        }
      });
    } catch (u) {
      c({
        type: "GET_LIST_FAILED",
        payload: u
      });
    }
  }, i = O(
    (u, C) => {
      const l = r.initialTenantList.find((g) => g.object.id === u) || r.list.find((g) => g.object.id === u);
      if (!l)
        return;
      const x = C ? r.selectedTenantList.filter((g) => g.object.id !== u) : r.selectedTenantList.some((g) => g.object.id === u) ? r.selectedTenantList : [...r.selectedTenantList, l];
      c({
        type: "CHANGE_SELECTED_LIST",
        payload: Pe(x)
      });
    },
    [r]
  ), d = O(
    (u, C, l) => {
      const x = r.selectedTenantList.map((g) => {
        if (g.object.id !== u)
          return g;
        const S = {
          ...Fe(g),
          [C]: l
        };
        return C === "steward" && (S.owner = l, S.dataSteward = l), C === "dataSteward" && (S.steward = l, S.owner = l), C === "owner" && (S.steward = l, S.dataSteward = l), {
          ...g,
          roles: S
        };
      });
      c({
        type: "CHANGE_SELECTED_LIST",
        payload: x
      });
    },
    [r.selectedTenantList]
  ), m = O(() => {
    const u = new Map(
      r.initialTenantList.map((T) => [T.object.id, T])
    ), C = new Set(
      r.selectedTenantList.map((T) => T.object.id)
    ), l = r.selectedTenantList.filter(
      (T) => !u.has(T.object.id)
    ), x = r.initialTenantList.filter(
      (T) => !C.has(T.object.id)
    ), g = r.selectedTenantList.reduce(
      (T, S) => {
        const j = u.get(S.object.id);
        return j && zs(j, S) && T.push({
          ...S,
          roleChanges: Mt(j, S)
        }), T;
      },
      []
    );
    return { added: l, deleted: x, updated: g };
  }, [r]);
  return _(() => {
    o();
  }, []), {
    ...r,
    changeSelectedList: i,
    changeRole: d,
    prepareListForSave: m
  };
}, Vs = {
  [U.DATA_SOURCES]: {
    name: U.DATA_SOURCES,
    titleAddedSection: "Added data sources",
    titleDropdownSection: "Add new data source",
    placeholder: "Select data source..."
  },
  [U.METADATA]: {
    name: U.METADATA,
    titleAddedSection: "Added attributes",
    titleDropdownSection: "Add new attribute",
    placeholder: "Select attribute..."
  },
  [U.USERS]: {
    name: U.USERS,
    titleAddedSection: "Added users",
    titleDropdownSection: "Add new users",
    placeholder: "Select users..."
  }
}, Hs = (e) => {
  const { tenantId: s, onChange: t, hasParent: a, getList: r, getListByTenant: c, type: o } = e, { titleAddedSection: i, titleDropdownSection: d, placeholder: m, name: u } = Vs[o], {
    list: C,
    selectedTenantList: l,
    status: x,
    changeSelectedList: g,
    changeRole: T,
    prepareListForSave: S
  } = Ks(s, a, r, c), j = o === U.USERS, y = ce.useMemo(() => {
    const N = l.map((W) => W.object.id);
    return C.filter((W) => !N.includes(W.object.id));
  }, [C, l]);
  if (_(() => {
    t(S());
  }, [l]), [v.INITIAL, v.IN_PROGRESS].includes(x))
    return /* @__PURE__ */ n.jsx(ht, { children: /* @__PURE__ */ n.jsx(X, { size: 32 }) });
  const A = /* @__PURE__ */ n.jsxs(p, { container: !0, mt: j ? 0 : 2, children: [
    j && l.length > 0 && /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, container: !0, px: 1, pb: 0.75, alignItems: "center", children: [
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 7, children: /* @__PURE__ */ n.jsx(
        he,
        {
          variant: "caption",
          color: "text.secondary",
          fontWeight: 700,
          children: "User"
        }
      ) }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ n.jsx(
        he,
        {
          variant: "caption",
          color: "text.secondary",
          fontWeight: 700,
          children: "Steward"
        }
      ) }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ n.jsx(
        he,
        {
          variant: "caption",
          color: "text.secondary",
          fontWeight: 700,
          children: "Admin"
        }
      ) }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 1 })
    ] }),
    l.length > 0 ? l.map((N) => /* @__PURE__ */ n.jsxs(
      $s,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ n.jsx(p, { item: !0, xs: j ? 7 : 11, children: N.object.title }),
          j && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
            /* @__PURE__ */ n.jsx(p, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ n.jsx(
              $e,
              {
                checked: se(N.roles),
                onChange: (R) => T(
                  N.object.id,
                  "steward",
                  R.target.checked
                ),
                size: "small"
              }
            ) }),
            /* @__PURE__ */ n.jsx(p, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ n.jsx(
              $e,
              {
                checked: de(N.roles),
                onChange: (R) => T(N.object.id, "admin", R.target.checked),
                size: "small"
              }
            ) })
          ] }),
          /* @__PURE__ */ n.jsx(p, { item: !0, xs: j ? 1 : void 0, textAlign: "center", children: /* @__PURE__ */ n.jsx(
            w,
            {
              sx: { minWidth: 20 },
              color: "error",
              onClick: () => g(N.object.id, !0),
              children: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate", fontSize: "small" })
            }
          ) })
        ]
      },
      N.object.id
    )) : /* @__PURE__ */ n.jsx("div", { children: "-" })
  ] });
  return /* @__PURE__ */ n.jsxs(p, { container: !0, p: 2, spacing: 2, children: [
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: j ? (
      // The data sources / metadata modals wrap the list in FormElement
      // (font-size 13px); the users list is rendered raw, so it looked
      // bigger. Match the 13px so all three modals are equal — PRO-3961 #2.
      /* @__PURE__ */ n.jsx(p, { sx: { fontSize: 13 }, children: A })
    ) : /* @__PURE__ */ n.jsx(I, { name: "existingEntities", textLabel: i, children: A }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: u, textLabel: d, children: /* @__PURE__ */ n.jsx(
      yt,
      {
        className: "",
        name: u,
        id: u,
        options: y,
        value: { object: { title: "" } },
        placeholder: m,
        onChange: (N, R) => R && g(R.object.id, !1),
        fullWidth: !0,
        getOptionLabel: (N) => N.object.title,
        isOptionEqualToValue: (N, R) => N.id === (R == null ? void 0 : R.id),
        disableClearable: !0
      }
    ) }) }) })
  ] });
}, Ce = (e) => {
  var l, x, g;
  const {
    onClose: s,
    onChange: t,
    tenantId: a,
    hasParent: r,
    getList: c,
    getListByTenant: o,
    type: i
  } = e, { enqueueSnackbar: d } = z(), [m, u] = E(), C = O(async () => {
    const T = await t(m, a);
    if (T.error) {
      d(T.message, { variant: "error" });
      return;
    }
    d(T.message, { variant: "success" }), s();
  }, [m]);
  return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      Hs,
      {
        tenantId: a,
        hasParent: r,
        onChange: (T) => {
          u(T);
        },
        getList: c,
        getListByTenant: o,
        type: i
      }
    ) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ n.jsxs(H, { children: [
      /* @__PURE__ */ n.jsx(
        w,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        w,
        {
          onClick: C,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
          name: "save",
          disabled: !((l = m == null ? void 0 : m.added) != null && l.length) && !((x = m == null ? void 0 : m.deleted) != null && x.length) && !((g = m == null ? void 0 : m.updated) != null && g.length),
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}, Ys = ({ analysisTypes: e }) => {
  const s = Z(), { openModal: t, closeModal: a } = M(ae), { enqueueSnackbar: r } = z(), { path: c } = M(
    B
  ), o = Ve((y) => y.user), { tenants: i, setActiveTenant: d, updateTenant: m } = He(
    o.data
  );
  _(() => {
    s(
      Q([
        {
          name: "Settings",
          path: `${c}`
        },
        {
          name: "Tenants",
          path: `${c}/tenants`
        }
      ])
    );
  }, [c]);
  const u = Se("Users", Ds), C = Se(
    "Data sources",
    Rs
  ), l = Se("Metadata", ks), x = (y, A) => {
    t(
      () => /* @__PURE__ */ n.jsx(
        Ps,
        {
          values: y,
          onClose: a,
          analysisTypes: e,
          currentAnalysisTypes: A,
          currentUser: o,
          onFinish: (N) => {
            m(N), r({
              message: "Tenant Analysis Types Changed",
              variant: "success"
            }), a();
          }
        }
      ),
      "Change Tenant Analysis Types",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, g = (y, A) => {
    t(
      () => /* @__PURE__ */ n.jsx(
        Ce,
        {
          onClose: a,
          tenantId: y,
          hasParent: A,
          onChange: C,
          getList: Dt,
          getListByTenant: _s,
          type: U.DATA_SOURCES
        }
      ),
      "Data sources",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, T = (y, A) => {
    t(
      () => /* @__PURE__ */ n.jsx(
        Ce,
        {
          onClose: a,
          tenantId: y,
          hasParent: A,
          onChange: u,
          getList: Lt,
          getListByTenant: vt,
          type: U.USERS
        }
      ),
      "Users",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, S = (y, A) => {
    t(
      () => /* @__PURE__ */ n.jsx(
        Ce,
        {
          onClose: a,
          tenantId: y,
          hasParent: A,
          onChange: l,
          getList: $n,
          getListByTenant: qn,
          type: U.METADATA
        }
      ),
      "Metadata",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, j = F(() => Ms(g, T, S), []);
  return ce.useEffect(() => {
    document.title = "Prometheus - Tenants";
  }, []), /* @__PURE__ */ n.jsx(
    p,
    {
      container: !0,
      px: 6,
      py: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
        le,
        {
          columns: j,
          data: i,
          loadingMessage: "Loading tenants...",
          hideSettings: !0,
          totalElements: i == null ? void 0 : i.length,
          onEdit: async (y) => {
            await d(y.value), location.reload();
          },
          onRowClick: async (y) => {
            const A = await Nt(
              y.original.id
            );
            x(y.original, A);
          }
        }
      ) })
    }
  );
}, Js = (e) => [
  {
    name: "Settings",
    path: `${e}`
  },
  {
    name: "Data sources",
    path: `${e}/data-sources`
  }
], Xs = (e) => ({
  rowId: "id",
  loadingMessage: "Loading data sources...",
  addButtonTitle: "Add data source",
  tableTitle: "Data sources",
  createCrudMethod: (s, t) => ve(
    s,
    t,
    Dt,
    () => Promise.resolve()
  ),
  createFiltersPanel: (s, t) => Le(
    s,
    t,
    Ss
  ),
  createSortingMethod: (s) => we(s, {
    getSorting: fs
  }),
  cols: [
    be({
      cell: ({
        row: s
      }) => {
        const { original: t } = s;
        return /* @__PURE__ */ n.jsx(n.Fragment, { children: t ? /* @__PURE__ */ n.jsx(Bt, { dataSource: t }) : "" });
      }
    }),
    {
      header: "Organization",
      id: "organization",
      accessorFn: (s) => {
        var t;
        return ((t = s.dataNode) == null ? void 0 : t.name) || "";
      },
      enableSorting: !1,
      size: 160
    },
    {
      header: "Model type",
      accessorKey: "modelType",
      size: 100,
      minSize: 80
    },
    // {
    //   header: 'Version',
    //   accessor: 'cdmVersion',
    //   Cell: ({ value: cdmVersion }) => (
    //     <span>{parseCdmVersion(cdmVersion)}</span>
    //   ),
    // },
    {
      header: "Access type",
      accessorKey: "accessType",
      enableResizing: !1,
      size: 120,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: ({
        renderValue: s
      }) => {
        const t = rt();
        return s() ? /* @__PURE__ */ n.jsx(
          st,
          {
            light: !0,
            color: mn(s(), t),
            text: s(),
            align: "center"
          }
        ) : "";
      }
    },
    {
      id: "executionPolicy",
      header: "Execution policy",
      accessorKey: "executionPolicy",
      enableResizing: !1,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: ({
        renderValue: s
      }) => {
        const t = rt();
        return s() ? /* @__PURE__ */ n.jsx(
          st,
          {
            light: !0,
            text: s(),
            color: hn(s(), t),
            align: "center",
            minWidth: 90
          }
        ) : "";
      }
    },
    {
      header: "",
      accessorKey: "id",
      enableSorting: !1,
      maxWidth: 40,
      meta: {
        columnType: "action"
      },
      cell: (s) => /* @__PURE__ */ n.jsx(Te, { text: "Add to tenant", color: "primary", width: "auto", children: /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(
        Ge,
        {
          iconName: "add",
          color: "default",
          size: "small",
          noExpand: !0,
          onClick: (t) => {
            t.stopPropagation(), e(s.row.original);
          }
        }
      ) }) })
    }
  ]
}), Zs = [
  {
    name: "Unrestricted",
    value: ze.PUBLIC
  },
  {
    name: "Restricted",
    value: ze.RESTRICTED
  }
], lt = V((e) => {
  var S;
  const { onClose: s, values: t, createMethod: a, updateMethod: r, isUpdate: c, afterCreate: o } = e, [i, d] = E({
    dataNodeId: ((S = t == null ? void 0 : t.dataNode) == null ? void 0 : S.id) || "",
    name: (t == null ? void 0 : t.name) || "",
    description: (t == null ? void 0 : t.description) || "",
    accessType: (t == null ? void 0 : t.accessType) || ze.PUBLIC,
    cdmVersion: (t == null ? void 0 : t.cdmVersion) || "",
    modelType: (t == null ? void 0 : t.modelType) || xn.CDM,
    values: [],
    tenants: []
  }), [m, u] = E(!1), [C, l] = E([]), [x, g] = E([]);
  _(() => {
    u(!0), It().then((j) => {
      g(
        j.content.map((y) => ({ name: y.name, value: y.code }))
      );
    }), Rt({}).then((j) => {
      l(
        j.content.map((y) => ({
          name: y.name,
          value: y.id
        }))
      ), u(!1);
    });
  }, []);
  const T = O(async () => {
    c ? await r(t.id, i) : await a(i), o == null || o();
  }, [i]);
  return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { elevated: !0, outlined: !0, children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    !m && C.length > 0 && /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "data-nodes", textLabel: "Data nodes", children: /* @__PURE__ */ n.jsx(
      te,
      {
        name: "data-nodes",
        id: "data-nodes",
        options: C,
        value: i.dataNodeId,
        onChange: (j) => {
          d({
            ...i,
            dataNodeId: j
          });
        },
        placeholder: "Select data node...",
        className: "",
        disablePortal: !0,
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Name", children: /* @__PURE__ */ n.jsx(
      G,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        placeholder: "Enter name",
        value: i.name,
        onChange: (j) => {
          d({
            ...i,
            name: j.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "description", textLabel: "Description", children: /* @__PURE__ */ n.jsx(
      G,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        placeholder: "Enter description",
        value: i.description,
        onChange: (j) => {
          d({
            ...i,
            description: j.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 6, children: /* @__PURE__ */ n.jsx(I, { name: "access-type", textLabel: "Access type", required: !0, children: /* @__PURE__ */ n.jsx(
      te,
      {
        className: "",
        name: "access-type",
        disablePortal: !0,
        id: "access-type",
        options: Zs,
        value: i.accessType,
        placeholder: "Select type...",
        onChange: (j) => {
          d({ ...i, accessType: j });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 6, children: /* @__PURE__ */ n.jsx(I, { name: "ex", textLabel: "Model type", required: !0, children: /* @__PURE__ */ n.jsx(
      te,
      {
        className: "",
        name: "ex",
        disablePortal: !0,
        id: "ex",
        options: x,
        value: i.modelType,
        placeholder: "Select type...",
        onChange: (j) => {
          d({ ...i, modelType: j });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
      /* @__PURE__ */ n.jsx(
        w,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        w,
        {
          onClick: T,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), Qs = () => {
  const e = Z(), { openModal: s, closeModal: t } = M(ae), a = M(
    B
  ), { enqueueSnackbar: r } = z(), [c, o] = E();
  _(() => {
    e(Q(Js(a.path)));
  }, [a.path]);
  const i = () => {
    s(
      () => /* @__PURE__ */ n.jsx(
        lt,
        {
          createMethod: Ns,
          afterCreate: () => {
            r({
              message: "Create data source successfully",
              variant: "success"
            }), o(ne()), t();
          },
          onClose: t
        }
      ),
      "Add data source",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  }, d = (u) => {
    s(
      () => /* @__PURE__ */ n.jsx(
        lt,
        {
          isUpdate: !0,
          values: u.original,
          updateMethod: Es,
          afterCreate: () => {
            r({
              message: "Update data source successfully",
              variant: "success"
            }), o(ne()), t();
          },
          onClose: t
        }
      ),
      "Update data source",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  }, m = (u) => {
    s(
      () => /* @__PURE__ */ n.jsx(
        Ye,
        {
          user: u,
          typeEntity: Ke.USERS,
          onClose: () => {
            o(ne()), t();
          }
        }
      ),
      "Add user to tenant",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  };
  return /* @__PURE__ */ n.jsx(p, { container: !0, minHeight: "100%", children: /* @__PURE__ */ n.jsx(
    fe,
    {
      moduleConfig: a,
      listConfig: Xs(m),
      onRowClick: d,
      reloadId: c,
      onCreate: i,
      variant: "no-header"
    }
  ) });
}, ea = (e) => {
  const s = [
    {
      title: "Tenants",
      value: "",
      end: !0
    },
    {
      title: "User Groups",
      value: "groups"
    },
    // {
    //   title: 'Data sources',
    //   value: `data-sources`,
    // },
    {
      title: "Users",
      value: "users"
    },
    {
      title: "Metadata",
      value: "metadata"
    },
    {
      title: "Model Types",
      value: "model-types"
    },
    {
      title: "Study Types",
      value: "study-types"
    },
    {
      title: "Data nodes",
      value: "data-nodes"
    },
    {
      title: "Audit Logs",
      value: "audit-logs"
    }
  ];
  return e && s.push({
    title: "Analysis settings",
    value: "analysis-settings"
  }), s;
}, ta = (e) => ({
  rowId: "id",
  loadingMessage: "Loading data nodes...",
  addButtonTitle: "Add data node",
  tableTitle: "Data nodes",
  createCrudMethod: (s, t) => ve(
    s,
    t,
    Rt
  ),
  createFiltersPanel: (s, t) => Le(
    s,
    t,
    bs
  ),
  createSortingMethod(s) {
    return we(s, {
      getSorting: As
    });
  },
  cols: [
    // Plain (non-bold) name to match the other Settings tabs — PRO-3961 #10.
    be({
      size: 300,
      cell: ({ getValue: s }) => s() ?? "-"
    }),
    {
      header: "Node address",
      accessorKey: "nodeAddress",
      id: "nodeAddress"
    },
    {
      header: "Register address",
      accessorKey: "registrarAddress",
      id: "registrarAddress"
    },
    {
      header: "Published",
      accessorKey: "published",
      enableSorting: !1,
      size: 90,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: (s) => s.getValue() ? /* @__PURE__ */ n.jsx(L, { iconName: "check", className: "icon-analysis" }) : "-"
    },
    {
      header: "Virtual",
      accessorKey: "virtual",
      enableSorting: !1,
      size: 90,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: (s) => s.renderValue() ? /* @__PURE__ */ n.jsx(L, { iconName: "check", className: "icon-analysis" }) : "-"
    },
    {
      header: "Description",
      accessorKey: "description",
      size: 220
    }
  ]
}), na = (e) => [
  {
    name: "Settings",
    path: `${e}`
  },
  {
    name: "Data nodes",
    path: `${e}/data-nodes`
  }
], sa = V((e) => {
  const {
    onClose: s,
    values: t,
    createMethod: a,
    updateMethod: r,
    isUpdate: c,
    afterCreate: o,
    disableForm: i
  } = e, [d, m] = E(!1), [u, C] = E(
    t || {
      name: "",
      description: ""
    }
  ), l = O(async () => {
    m(!0), c ? (await r(t.id, u), m(!1)) : (await a(u), m(!1)), o == null || o();
  }, [u]);
  return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ n.jsx(
      G,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        placeholder: "Enter name",
        disabled: i,
        value: u.name,
        onChange: (x) => {
          C({
            ...u,
            name: x.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "description", textLabel: "Description", children: /* @__PURE__ */ n.jsx(
      G,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        placeholder: "Enter description",
        disabled: i,
        value: u.description,
        onChange: (x) => {
          C({
            ...u,
            description: x.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    !i && /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
      /* @__PURE__ */ n.jsx(
        w,
        {
          variant: "outlined",
          onClick: s,
          disabled: d,
          startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ n.jsx(
        w,
        {
          onClick: l,
          variant: "contained",
          disabled: d || gt(u.name),
          color: "success",
          startIcon: d ? /* @__PURE__ */ n.jsx(X, { size: 16 }) : /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), aa = () => {
  const e = Z(), { openModal: s, closeModal: t } = M(ae), a = M(
    B
  ), { enqueueSnackbar: r } = z(), [c, o] = E();
  _(() => {
    e(Q(na(a.path)));
  }, [a.path]);
  const i = (d) => {
    s(
      () => /* @__PURE__ */ n.jsx(
        sa,
        {
          isUpdate: !0,
          values: d.original,
          updateMethod: Cs,
          disableForm: !0,
          afterCreate: () => {
            r({
              message: "Update data node successfully",
              variant: "success"
            }), o(ne()), t();
          },
          onClose: t
        }
      ),
      "Data node details",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  };
  return /* @__PURE__ */ n.jsx(p, { container: !0, children: /* @__PURE__ */ n.jsx(
    fe,
    {
      moduleConfig: a,
      listConfig: ta(),
      onRowClick: i,
      reloadId: c,
      onCreate: void 0,
      uniqName: "data-nodes"
    }
  ) });
}, dt = {
  entityBreadcrumb: (e) => [
    {
      name: "Settings",
      path: `${e}`
    },
    {
      name: "Analysis settings",
      path: `${e}/analysis-settings`
    }
  ],
  filterMetadata: "&filter.metadata.subject=DATA_SOURCE&filter.metadata.subject=CONCEPT_SET&filter.metadata.subject=COHORT",
  columns: [
    be(),
    {
      header: "Active",
      accessorKey: "active",
      enableSorting: !1,
      size: 20,
      maxSize: 30,
      cell: ({ getValue: e, ...s }) => /* @__PURE__ */ n.jsx(me, { value: e(), ...s }),
      meta: {
        headerAlign: "center",
        align: "center"
      }
    }
  ]
}, ra = (e) => {
  const { list: s, listStatus: t } = e, a = Z(), { path: r, getHealthCheck: c } = M(
    B
  ), [o, i] = E(v.INITIAL), d = F(
    () => [...s || []].sort(
      (u, C) => (u.name || "").localeCompare(C.name || "", void 0, {
        sensitivity: "base"
      })
    ),
    [s]
  ), m = async (u) => {
    const C = {};
    d == null || d.forEach((l) => {
      l.id === u.row.id ? C[l.id] = u.value : C[l.id] = l.active;
    });
    try {
      await ds(C), i(v.SUCCESS);
    } catch {
      i(v.ERROR);
    }
  };
  return _(() => {
    a(Q(dt.entityBreadcrumb(r)));
  }, [r]), _(() => {
    document.title = "Prometheus - Analysis Settings";
  }, []), /* @__PURE__ */ n.jsx(
    p,
    {
      container: !0,
      px: 6,
      pb: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
        /* @__PURE__ */ n.jsx(xe, { title: "Analysis modules" }),
        /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
          le,
          {
            columns: dt.columns,
            data: d,
            loadingMessage: "",
            loading: t === v.IN_PROGRESS,
            totalElements: d.length,
            hidePagination: !0,
            pageSize: d.length,
            hideSettings: !0,
            onEdit: m
          }
        ) })
      ] })
    }
  );
}, oa = (e) => {
  const { children: s, tabs: t } = e;
  return /* @__PURE__ */ n.jsxs(Wt, { children: [
    /* @__PURE__ */ n.jsxs(Kt, { children: [
      /* @__PURE__ */ n.jsx(Vt, { title: "Settings", iconName: "admin" }),
      /* @__PURE__ */ n.jsx(Ht, { tabs: t, withRouting: !0 })
    ] }),
    /* @__PURE__ */ n.jsx(Yt, { children: s })
  ] });
}, ia = (e) => [
  {
    name: "Settings",
    path: `${e}`
  },
  {
    name: "Study Types",
    path: `${e}/study-types`
  }
], ca = (e, s) => [
  {
    header: "Name",
    accessorKey: "name",
    size: 100
  },
  {
    header: "Analysis Types",
    id: "analysisTypes",
    accessorFn: (t) => {
      var a;
      return (a = t.analysisTypes) == null ? void 0 : a.map(
        (r) => {
          var c;
          return (c = e == null ? void 0 : e.find((o) => o.type === r)) == null ? void 0 : c.name;
        }
      );
    },
    cell: Ee,
    enableSorting: !1
  },
  {
    header: "Consent",
    accessorKey: "consent",
    enableSorting: !1,
    enableResizing: !1,
    meta: { align: "center", headerAlign: "center" },
    size: 40,
    maxSize: 40,
    cell: ({ getValue: t }) => /* @__PURE__ */ n.jsx(
      Te,
      {
        text: t() ? "Active" : "Not active",
        color: "primary",
        width: "auto",
        children: /* @__PURE__ */ n.jsx("div", { children: t() ? /* @__PURE__ */ n.jsx(L, { iconName: "check", className: "icon-analysis" }) : /* @__PURE__ */ n.jsx(n.Fragment, { children: "-" }) })
      }
    )
  },
  {
    header: "",
    accessorKey: "id",
    id: "item-id",
    enableSorting: !1,
    enableResizing: !1,
    size: 40,
    maxSize: 40,
    meta: {
      columnType: "action"
    },
    cell: (t) => /* @__PURE__ */ n.jsx(
      Ae,
      {
        entityType: t.row.original.name,
        withConfirmation: !0,
        onRemove: () => s(t.row.original.id)
      }
    )
  }
], ut = V(
  (e) => {
    const { onClose: s, values: t, analysisTypes: a, onFinish: r } = e, [c, o] = E(!1), { enqueueSnackbar: i } = z(), [d, m] = E({
      id: t == null ? void 0 : t.id,
      name: (t == null ? void 0 : t.name) || "",
      analysisTypes: (t == null ? void 0 : t.analysisTypes) || [],
      requireUserConsent: (t == null ? void 0 : t.requireUserConsent) || !1,
      requireUserConsentMessage: (t == null ? void 0 : t.requireUserConsentMessage) || ""
    }), u = O(async () => {
      o(!0);
      try {
        const l = t != null && t.id ? await Zn(t.id, d) : await Xn(d);
        r(l), o(!1);
      } catch (l) {
        o(!1), i({
          message: "Something went wrong",
          variant: "error"
        }), console.error(l);
      }
    }, [d]), C = F(() => !d.name || d.analysisTypes.length === 0, [d]);
    return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ n.jsx(
        G,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          placeholder: "Enter name",
          value: d.name,
          onChange: (l) => {
            m((x) => ({ ...x, name: l.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
        /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Analysis Types" }),
        /* @__PURE__ */ n.jsx(
          _e,
          {
            study: d,
            analysisTypes: a,
            onChange: (l) => {
              m((x) => ({
                ...x,
                analysisTypes: l
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs("label", { children: [
        /* @__PURE__ */ n.jsx(
          $e,
          {
            name: "createNew",
            onChange: () => {
              m((l) => ({
                ...l,
                requireUserConsent: !l.requireUserConsent
              }));
            },
            checked: d.requireUserConsent,
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ n.jsx(
          he,
          {
            variant: "subtitle2",
            component: "span",
            lineHeight: "26px",
            children: "Require user consent"
          }
        )
      ] }) }),
      /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
        /* @__PURE__ */ n.jsx(
          nn,
          {
            id: "message",
            name: "message",
            value: d.requireUserConsentMessage,
            onChange: (l) => {
              m((x) => ({
                ...x,
                requireUserConsentMessage: l
              }));
            },
            maxRows: 10,
            minRows: 5,
            disableHorizontalResize: !0,
            placeholder: "Enter consent form"
          }
        ),
        /* @__PURE__ */ n.jsx(Ne, { sx: { mt: 2 } })
      ] }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
        /* @__PURE__ */ n.jsx(
          w,
          {
            variant: "outlined",
            onClick: s,
            startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ n.jsx(
          w,
          {
            disabled: c || C,
            onClick: u,
            variant: "contained",
            color: "success",
            startIcon: c ? /* @__PURE__ */ n.jsx(X, { size: 16 }) : /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
            name: "save",
            children: t ? "Change" : "Create"
          }
        )
      ] }) })
    ] }) }) });
  }
), la = (e) => {
  const { analysisTypes: s } = e, t = Z(), { openModal: a, closeModal: r } = M(ae), [c, o] = E([]), [i, d] = E([]), { path: m } = M(
    B
  ), { enqueueSnackbar: u } = z();
  _(() => {
    Kn().then((T) => {
      o(yn(T.content)), d(T.actions);
    });
  }, []), _(() => {
    t(Q(ia(m)));
  }, [m]);
  const C = (T) => {
    a(
      () => /* @__PURE__ */ n.jsx(
        ut,
        {
          values: T,
          analysisTypes: s,
          onFinish: (S) => {
            const j = [...c], y = j.findIndex((A) => A.id === S.id);
            y !== -1 ? j.splice(y, 1, S) : j.unshift(S), o(j), u({
              message: "Study type created",
              variant: "success"
            }), r();
          },
          onClose: r
        }
      ),
      "Create Study Type",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: r
      }
    );
  }, l = O(
    async (T) => {
      const S = [...c];
      try {
        await Qn(T);
        const j = S.findIndex((y) => y.id === T);
        S.splice(j, 1), o(S), u({
          message: "Study type deleted",
          variant: "success"
        });
      } catch (j) {
        console.error(j);
      }
    },
    [c]
  ), x = O(
    async (T) => {
      try {
        const S = await Hn(T), j = await Yn(T), y = {
          ...S,
          requireUserConsent: j == null ? void 0 : j.required,
          requireUserConsentMessage: j == null ? void 0 : j.text
        };
        a(
          () => /* @__PURE__ */ n.jsx(
            ut,
            {
              values: y,
              analysisTypes: s,
              onFinish: (A) => {
                const N = [...c], R = N.findIndex(
                  (W) => W.id === A.id
                );
                R !== -1 ? N.splice(R, 1, A) : N.unshift(A), o(N), u({
                  message: y ? "Study type changed" : "Study type created",
                  variant: "success"
                }), r();
              },
              onClose: r
            }
          ),
          y ? "Change Study Type" : "Create Study Type",
          {
            closeOnClickOutside: !0,
            width: "700px",
            onClose: r
          }
        );
      } catch (S) {
        console.error(S);
      }
    },
    [s, c]
  ), g = F(() => ca(s, l), [c]);
  return _(() => {
    document.title = "Prometheus - Study Types";
  }, []), /* @__PURE__ */ n.jsx(p, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
    /* @__PURE__ */ n.jsx(
      xe,
      {
        title: "Study Types",
        canCreate: !0,
        onCreate: () => C(),
        createButtonName: "Create Study Type"
      }
    ),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      le,
      {
        columns: g,
        data: c,
        loadingMessage: "",
        totalElements: c.length,
        onRowClick: async (T) => {
          await x(T.original.id);
        },
        hideSettings: !0
      }
    ) })
  ] }) });
}, da = ({ analysisTypes: e }) => /* @__PURE__ */ n.jsx(la, { analysisTypes: e }), ua = (e, s) => [
  {
    header: "Title",
    accessorKey: "title",
    size: 180
  },
  {
    header: "Tenant",
    accessorKey: "parent.name",
    enableSorting: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    header: "Users",
    accessorKey: "participants",
    meta: {
      align: "center",
      headerAlign: "center"
    },
    size: 120,
    maxSize: 120,
    cell: (t) => /* @__PURE__ */ n.jsx(
      w,
      {
        onClick: (a) => {
          a.stopPropagation(), e(
            t.row.original.id,
            !!t.row.original.parent
          );
        },
        variant: "text",
        size: "small",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "users"
      }
    )
  },
  {
    header: "Analysis Types",
    accessorFn: (t) => {
      var a, r;
      return ((r = (a = t.relations) == null ? void 0 : a.analysisTypes) == null ? void 0 : r.length) > 0 ? t.relations.analysisTypes.map((c) => c.name) : ["-"];
    },
    cell: Ee,
    size: 300,
    enableSorting: !1
  },
  {
    header: "",
    accessorKey: "id",
    isCropped: !0,
    enableSorting: !1,
    maxSize: 100,
    meta: { columnType: "action" },
    cell: (t) => /* @__PURE__ */ n.jsx(
      Ae,
      {
        entityType: t.row.original.name,
        withConfirmation: !0,
        onRemove: () => s(t.row.original.id)
      }
    )
  }
], pa = {
  add: At,
  delete: ft,
  update: Et
}, pt = (e, s, t = []) => {
  var r, c, o;
  const a = (o = (c = (r = e.find((i) => i.value === s)) == null ? void 0 : r.relations) == null ? void 0 : c.analysisTypes) == null ? void 0 : o.map((i) => i.type);
  return t.filter(
    (i) => !a.includes(i)
  );
}, ma = V(
  (e) => {
    var S, j;
    const {
      onClose: s,
      values: t,
      analysisTypes: a,
      onFinish: r,
      currentAnalysisTypes: c,
      tenants: o
    } = e, [i, d] = E(!1), { enqueueSnackbar: m } = z(), [u, C] = E({
      id: t == null ? void 0 : t.id,
      title: (t == null ? void 0 : t.title) || "",
      parent: (t == null ? void 0 : t.parent.id) || ((S = o[0]) == null ? void 0 : S.value),
      analysisTypes: pt(
        o,
        (t == null ? void 0 : t.parent.id) || ((j = o[0]) == null ? void 0 : j.value),
        c
      ) || []
    }), l = O(async () => {
      d(!0);
      try {
        const y = t != null && t.id ? await Mn(t.id, {
          id: u.id,
          title: u.title
        }) : await kn(
          {
            title: u.title
          },
          u.parent
        );
        await wt(y.id, u.analysisTypes), r({
          ...y,
          relations: {
            analysisTypes: a.filter(
              (A) => u.analysisTypes.includes(A.type)
            )
          }
        }), d(!1);
      } catch (y) {
        d(!1), m({
          message: "Something went wrong",
          variant: "error"
        }), console.error(y);
      }
    }, [u, o]), x = F(() => {
      var A;
      const y = (A = t == null ? void 0 : t.relations) == null ? void 0 : A.analysisTypes.map(
        (N) => N.type
      );
      return (t == null ? void 0 : t.title) === u.title && y.length === u.analysisTypes.length && gn(y, u.analysisTypes).length === 0;
    }, [t, u]), g = (y) => {
      var N, R, W;
      const A = ((W = (R = (N = o.find((re) => re.value === y)) == null ? void 0 : N.relations) == null ? void 0 : R.analysisTypes) == null ? void 0 : W.map((re) => re.type)) || [];
      return a.length === A.length || A.length === 0 ? [] : a.filter((re) => !A.includes(re.type));
    };
    _(() => {
      C((y) => ({
        ...y,
        analysisTypes: pt(
          o,
          u.parent,
          u.analysisTypes
        )
      }));
    }, [u.parent]);
    const T = F(() => !u.title || !u.parent, [u]);
    return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ n.jsx(
        G,
        {
          id: "title",
          name: "title",
          type: "text",
          size: "medium",
          placeholder: "Enter title...",
          value: u.title,
          onChange: (y) => {
            C((A) => ({ ...A, title: y.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "parent", textLabel: "Tenant", required: !0, children: /* @__PURE__ */ n.jsx(
        te,
        {
          className: "",
          name: "parent",
          disablePortal: !0,
          id: "parent",
          disabled: !!u.id,
          options: o,
          value: u.parent,
          placeholder: "Select tenant",
          onChange: (y) => {
            C({ ...u, parent: y });
          },
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
        /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Analysis Types" }),
        /* @__PURE__ */ n.jsx(
          _e,
          {
            study: {
              analysisTypes: u.analysisTypes
            },
            analysisTypes: g(u.parent),
            onChange: (y) => {
              C((A) => ({
                ...A,
                analysisTypes: y
              }));
            }
          }
        ),
        /* @__PURE__ */ n.jsx(Ne, { sx: { mt: 2 } })
      ] }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
        /* @__PURE__ */ n.jsx(
          w,
          {
            variant: "outlined",
            onClick: s,
            size: "small",
            startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ n.jsx(
          w,
          {
            disabled: i || T || x,
            onClick: l,
            variant: "contained",
            size: "small",
            color: "success",
            startIcon: i ? /* @__PURE__ */ n.jsx(X, { size: 16 }) : /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
            name: "save",
            children: t ? "Change" : "Create"
          }
        )
      ] }) })
    ] }) }) });
  }
), ha = ({ analysisTypes: e }) => {
  const s = Z(), { openModal: t, closeModal: a } = M(ae), { path: r, subModules: c } = M(
    B
  ), { enqueueSnackbar: o } = z(), i = Ve(
    (j) => j.user
  ), { tenants: d, groups: m, updateGroups: u, deleteGroups: C } = He(
    i.data
  ), l = Se("Users", pa);
  _(() => {
    s(
      Q([
        {
          name: "Settings",
          path: `${r}`
        },
        {
          name: "User Groups",
          path: `${r}/groups`
        }
      ])
    );
  }, [r]);
  const x = async (j, y) => {
    t(
      () => /* @__PURE__ */ n.jsx(
        Ce,
        {
          onClose: a,
          tenantId: j,
          hasParent: y,
          onChange: l,
          getList: Gn,
          getListByTenant: vt,
          type: U.USERS
        }
      ),
      "Users",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, g = (j, y) => {
    t(
      () => /* @__PURE__ */ n.jsx(
        ma,
        {
          values: j,
          onClose: a,
          analysisTypes: e,
          currentAnalysisTypes: y,
          tenants: d.map((A) => ({
            value: A.id,
            name: A.title,
            ...A
          })),
          currentUser: i,
          onFinish: (A) => {
            u(A), o({
              message: j ? "User group changed" : "User group created",
              variant: "success"
            }), a();
          }
        }
      ),
      j ? "Change User Group" : "Create User Group",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, T = O(async (j) => {
    try {
      await Pn(j), C(j), o({
        message: "User Group deleted",
        variant: "success"
      });
    } catch (y) {
      console.error(y);
    }
  }, []), S = F(() => ua(x, T), []);
  return ce.useEffect(() => {
    document.title = "Prometheus - User Groups";
  }, []), /* @__PURE__ */ n.jsx(p, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
    /* @__PURE__ */ n.jsx(
      xe,
      {
        title: "User Groups",
        canCreate: d.length > 0,
        onCreate: () => g(),
        createButtonName: "Create User Group"
      }
    ),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      le,
      {
        columns: S,
        data: m,
        loadingMessage: "Loading...",
        totalElements: m.length,
        hideSettings: !0,
        onRowClick: async (j) => {
          const y = await Nt(
            j.original.id
          );
          g(j.original, y);
        }
      }
    ) })
  ] }) });
}, ya = (e, s) => [
  {
    header: "Name",
    accessorKey: "name",
    size: 120,
    maxSize: 240
  },
  {
    header: "Code",
    accessorKey: "code",
    size: 120,
    maxSize: 240
  },
  {
    header: "Analysis Types",
    accessorFn: (t) => {
      var a, r;
      return ((r = (a = t.relations) == null ? void 0 : a.analysisTypes) == null ? void 0 : r.map(
        (c) => {
          var o;
          return (o = e == null ? void 0 : e.find((i) => i.type === (c.type || c))) == null ? void 0 : o.name;
        }
      )) ?? [];
    },
    cell: Ee,
    enableSording: !1,
    size: 300
  },
  {
    header: "",
    accessorKey: "id",
    enableSording: !1,
    enableResizing: !1,
    maxSize: 100,
    size: 40,
    meta: { columnType: "action" },
    cell: (t) => {
      var a, r;
      return (r = (a = t.row.original) == null ? void 0 : a.actions) != null && r.delete ? /* @__PURE__ */ n.jsx(
        Ae,
        {
          entityType: t.row.original.name,
          withConfirmation: !0,
          onRemove: () => s(t.row.original.code)
        }
      ) : /* @__PURE__ */ n.jsx(n.Fragment, {});
    }
  }
], ga = V(
  (e) => {
    var T, S, j;
    const { onClose: s, values: t, analysisTypes: a, onFinish: r, isChange: c } = e, [o, i] = E(!1), { enqueueSnackbar: d } = z(), [m, u] = E({
      id: t == null ? void 0 : t.id,
      name: (t == null ? void 0 : t.name) || "",
      code: (t == null ? void 0 : t.code) || "",
      analysisTypes: ((S = (T = t == null ? void 0 : t.relations) == null ? void 0 : T.analysisTypes) == null ? void 0 : S.map((y) => y.type)) || [],
      deletedAnalysisTypes: []
    }), C = !c || ((j = t == null ? void 0 : t.actions) == null ? void 0 : j.update), l = O(async () => {
      try {
        const y = await Promise.all(
          ss(m.code, m.analysisTypes)
        ), A = await Promise.all(
          m.deletedAnalysisTypes.map(
            (N) => as(N, m.code)
          )
        );
        return {
          resUpdate: y,
          resDelete: A
        };
      } catch {
        return [];
      }
    }, [m]), x = O(async () => {
      i(!0);
      try {
        const y = await ts(m.code, {
          name: m.name,
          analysisTypes: m.analysisTypes
        });
        await l(), r({
          ...y,
          actions: {
            // `values` is undefined in Create mode, so guard the spread —
            // otherwise "Cannot read properties of undefined (reading
            // 'actions')" is thrown on Create (PRO-3961 #7.3).
            ...(t == null ? void 0 : t.actions) ?? {},
            delete: m.analysisTypes.length === 0
          },
          relations: {
            analysisTypes: m.analysisTypes
          }
        }), i(!1);
      } catch (y) {
        await l(), r(
          {
            ...m,
            relations: {
              analysisTypes: m.analysisTypes
            }
          },
          y
        ), i(!1);
      }
    }, [m]), g = F(() => !m.name || !(c || m.code), [m]);
    return /* @__PURE__ */ n.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ n.jsx(J, { children: /* @__PURE__ */ n.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ n.jsx(
        G,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          placeholder: "Enter name",
          disabled: !C,
          value: m.name,
          onChange: (y) => {
            u((A) => ({ ...A, name: y.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(I, { name: "code", textLabel: "Code", required: !0, children: /* @__PURE__ */ n.jsx(
        G,
        {
          id: "code",
          name: "code",
          type: "text",
          size: "medium",
          placeholder: "Enter code",
          disabled: c,
          value: m.code,
          onChange: (y) => {
            u((A) => ({ ...A, code: y.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
        /* @__PURE__ */ n.jsx(I, { name: "name", textLabel: "Analysis Types" }),
        /* @__PURE__ */ n.jsx(
          _e,
          {
            isLogger: !0,
            study: m,
            analysisTypes: a,
            onChangeLogger: ({ updated: y, deleted: A }) => {
              u((N) => ({
                ...N,
                analysisTypes: y,
                deletedAnalysisTypes: A
              }));
            }
          }
        ),
        /* @__PURE__ */ n.jsx(Ne, { sx: { mt: 2 } })
      ] }),
      /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsxs(H, { children: [
        /* @__PURE__ */ n.jsx(
          w,
          {
            variant: "outlined",
            onClick: s,
            startIcon: /* @__PURE__ */ n.jsx(L, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ n.jsx(
          w,
          {
            disabled: o || g,
            onClick: x,
            variant: "contained",
            color: "success",
            startIcon: o ? /* @__PURE__ */ n.jsx(X, { size: 16 }) : /* @__PURE__ */ n.jsx(L, { iconName: "submit" }),
            name: "save",
            children: t ? "Change" : "Create"
          }
        )
      ] }) })
    ] }) }) });
  }
), xa = (e) => {
  const { analysisTypes: s } = e, t = Z(), { openModal: a, closeModal: r } = M(ae), [c, o] = E([]), [i, d] = E([]), { path: m } = M(
    B
  ), { enqueueSnackbar: u } = z();
  _(() => {
    It().then((g) => {
      o(g.content), d(g.actions);
    });
  }, []), _(() => {
    t(
      Q([
        {
          name: "Settings",
          path: `${m}`
        },
        {
          name: "Model Types",
          path: `${m}/model-types`
        }
      ])
    );
  }, [m]);
  const C = (g, T) => {
    a(
      () => /* @__PURE__ */ n.jsx(
        ga,
        {
          values: g,
          isChange: T,
          analysisTypes: s,
          onFinish: (S, j) => {
            const y = [...c], A = y.findIndex(
              (N) => N.code === S.code
            );
            A !== -1 ? y.splice(A, 1, S) : y.unshift(S), o(y), u(j ? {
              message: j.message,
              variant: "error"
            } : {
              message: g ? "Model type changed" : "Model type created",
              variant: "success"
            }), r();
          },
          onClose: r
        }
      ),
      g ? "Change Model Type" : "Create Model Type",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: r
      }
    );
  }, l = O(
    async (g) => {
      const T = [...c];
      try {
        await ns(g);
        const S = T.findIndex((j) => j.code === g);
        T.splice(S, 1), o(T), u({
          message: "Model type deleted",
          variant: "success"
        });
      } catch (S) {
        console.error(S), u({
          message: S.message,
          variant: "error"
        });
      }
    },
    [c]
  ), x = F(() => ya(s, l), [c]);
  return ce.useEffect(() => {
    document.title = "Prometheus - Model Types";
  }, []), /* @__PURE__ */ n.jsx(p, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ n.jsxs(p, { item: !0, xs: 12, children: [
    /* @__PURE__ */ n.jsx(
      xe,
      {
        title: "Model Types",
        canCreate: i.find((g) => g === "create"),
        onCreate: () => C(),
        createButtonName: "Create Model Type"
      }
    ),
    /* @__PURE__ */ n.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ n.jsx(
      le,
      {
        columns: x,
        data: c,
        loadingMessage: "",
        hideSettings: !0,
        totalElements: c.length,
        onRowClick: async (g) => {
          const T = await es(g.original.code);
          C(T, !0);
        }
      }
    ) })
  ] }) });
}, Ta = {
  rowId: "id",
  loadingMessage: "Loading audit logs...",
  tableTitle: "Audit Logs",
  listInitialSort: { id: "timestamp", desc: !0 },
  createCrudMethod: () => ve(
    null,
    null,
    (e) => rs(e).then(ja)
  ),
  createFiltersPanel: () => {
    const e = (t) => String(
      (t == null ? void 0 : t.label) ?? (t == null ? void 0 : t.labelKey) ?? (t == null ? void 0 : t.value) ?? (t == null ? void 0 : t.key) ?? (t == null ? void 0 : t.name) ?? ""
    );
    return Le(null, null, (t) => is(t).then((a) => a != null && a.items ? {
      ...a,
      items: a.items.map(
        (r) => Array.isArray(r == null ? void 0 : r.options) ? {
          ...r,
          options: [...r.options].sort(
            (c, o) => e(c).localeCompare(e(o))
          )
        } : r
      )
    } : a));
  },
  createSortingMethod(e) {
    return we(e, {
      getSorting: cs
    });
  },
  cols: [
    Jt(),
    Xt({
      header: "User",
      accessorFn: (e) => e.actor.name || e.actor.email,
      id: "actor.name",
      size: 140
    }),
    {
      header: "Event",
      accessorKey: "type"
    },
    {
      header: "Description",
      accessorFn: (e) => Zt(e.content, e.id),
      size: 500,
      cell: ({
        renderValue: e
      }) => e()
    }
  ]
};
sn.TENANT_USER_REMOVED + "";
function ja(e) {
  return !e || !e.content || !e.content.length ? e : {
    ...e,
    content: e.content.map((s) => ({
      ...s,
      affectedEntities: s.content.reduce((t, a) => {
        if (typeof a != "string") {
          const [r, c] = Object.entries(a)[0], [o, i] = Object.entries(c)[0];
          t.push({ id: o, type: r, title: i });
        }
        return t;
      }, [])
    }))
  };
}
const Sa = (e) => {
  const s = M(
    B
  );
  return /* @__PURE__ */ n.jsx(p, { container: !0, children: /* @__PURE__ */ n.jsx(
    fe,
    {
      moduleConfig: s,
      listConfig: Ta,
      uniqName: "audit-log",
      disableRowClick: !0,
      exportFilteredResultsEnabled: !0,
      onExport: os
    }
  ) });
}, Ca = () => {
  const { state: e, status: s } = rn(ls), { original: t, status: a } = on(
    {}
  ), r = ea(!!(e != null && e.content));
  return [v.INITIAL, v.IN_PROGRESS].includes(s) && [v.INITIAL, v.IN_PROGRESS].includes(a) ? /* @__PURE__ */ n.jsx(Qt, { children: /* @__PURE__ */ n.jsx(X, { size: 62 }) }) : /* @__PURE__ */ n.jsx(oa, { tabs: r, children: /* @__PURE__ */ n.jsxs(mt, { children: [
    /* @__PURE__ */ n.jsx(q, { index: !0, element: /* @__PURE__ */ n.jsx(Ys, { analysisTypes: t }) }),
    /* @__PURE__ */ n.jsx(
      q,
      {
        path: "groups",
        element: /* @__PURE__ */ n.jsx(ha, { analysisTypes: t })
      }
    ),
    /* @__PURE__ */ n.jsx(
      q,
      {
        path: "study-types",
        element: /* @__PURE__ */ n.jsx(da, { analysisTypes: t })
      }
    ),
    /* @__PURE__ */ n.jsx(
      q,
      {
        path: "model-types",
        element: /* @__PURE__ */ n.jsx(xa, { analysisTypes: t })
      }
    ),
    /* @__PURE__ */ n.jsx(q, { path: "metadata", element: /* @__PURE__ */ n.jsx(xs, {}) }),
    /* @__PURE__ */ n.jsx(q, { path: "data-sources", element: /* @__PURE__ */ n.jsx(Qs, {}) }),
    /* @__PURE__ */ n.jsx(q, { path: "data-nodes", element: /* @__PURE__ */ n.jsx(aa, {}) }),
    /* @__PURE__ */ n.jsx(q, { path: "users", element: /* @__PURE__ */ n.jsx(js, {}) }),
    /* @__PURE__ */ n.jsx(
      q,
      {
        path: "analysis-settings",
        element: /* @__PURE__ */ n.jsx(ra, { list: e == null ? void 0 : e.content })
      }
    ),
    /* @__PURE__ */ n.jsx(q, { path: "audit-logs", element: /* @__PURE__ */ n.jsx(Sa, {}) })
  ] }) });
}, B = Ft(null), ba = (e) => {
  const { path: s, title: t, name: a, rootSettings: r, initStorage: c, getHealthCheck: o } = e, [i, d] = E(r), [m, u] = E(!0);
  return _(() => {
    r || d({
      rootPath: s,
      rootTitle: t
    }), u(!1), document.title = "Prometheus - Settings";
  }, []), m ? /* @__PURE__ */ n.jsx(ht, { children: /* @__PURE__ */ n.jsx(X, { size: 32 }) }) : /* @__PURE__ */ n.jsx(
    B.Provider,
    {
      value: { ...e, rootSettings: i, getHealthCheck: o },
      children: /* @__PURE__ */ n.jsx(mt, { children: /* @__PURE__ */ n.jsx(q, { path: "/*", element: /* @__PURE__ */ n.jsx(Ca, {}) }) })
    }
  );
}, ka = (e) => {
  const { type: s } = e;
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    !s && /* @__PURE__ */ n.jsx(ba, { ...e }),
    s === "component" && /* @__PURE__ */ n.jsx(bn, { ...e })
  ] });
};
export {
  ka as Admin
};
